(() => {
  if (customElements.get('hc-order-builder')) return;

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const unique = (values) => [...new Set(values)];

  const languageOriginalText = new WeakMap();
  const languageOriginalAttributes = new WeakMap();

  const emailIsValid = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());

  const collegeDegreeOptions = [
    'Associate of Arts | Associate of Arts',
    'Associate of Science | Associate of Science',
    'Associate of Business | Associate of Business',
    'Bachelor of Arts | Bachelor of Arts',
    'Bachelor of Science | Bachelor of Science',
    'Bachelor of Business Administration | Bachelor of Business Administration',
    'Master of Arts | Master of Arts',
    'Master of Science | Master of Science',
    'MBA Master of Business Administration | MBA Master of Business Administration',
    'PhD Doctor of Philosophy | PhD Doctor of Philosophy',
    'Other | Other'
  ].join('\n');

  const resourceIsActive = (config) =>
    String(config.version || '').startsWith('resource-native');

  const internationalLanguagePilots = {
    'ireland-college-university-match-diploma': {
      translatedLanguage: 'Irish',
      locale: 'ga',
      englishButton: 'View in English',
      translatedButton: 'Féach i nGaeilge',
      cartAriaTemplate: 'Oscail an chairt le [count] mír',
      translations: {
        'Finished your High School Equivalency? Celebrate it with a personalized keepsake.': 'Ar chríochnaigh tú do Choibhéis Ardscoile? Ceiliúir é le cuimhneachán pearsantaithe.',
        'Paid proof options where offered': 'Roghanna promhaidh íoctha nuair a thairgtear iad',
        'Support Mon–Fri, 9–4 ET': 'Tacaíocht Luan–Aoine, 9–4 Am an Oirthir',
        'Open navigation': 'Oscail an nascleanúint',
        'Mobile navigation': 'Nascleanúint mhóibíleach',
        'Main navigation': 'Príomhnascleanúint',
        'Menu': 'Roghchlár',
        'Home': 'Baile',
        'Diploma Maker': 'Déantóir Dioplóma',
        'View all Diploma Maker': 'Féach ar gach Déantóir Dioplóma',
        'Homeschool Diplomas': 'Dioplómaí Oideachais Baile',
        'High School Equivalency Diplomas': 'Dioplómaí Coibhéise Ardscoile',
        'High School Diplomas': 'Dioplómaí Meánscoile',
        'USA College & University Diplomas': 'Dioplómaí Coláiste agus Ollscoile SAM',
        'Transcript Maker': 'Déantóir Tras-scríbhinní',
        'View all Transcript Maker': 'Féach ar gach Déantóir Tras-scríbhinní',
        'High School Equivalency Score Transcripts': 'Tras-scríbhinní Scóir Coibhéise Ardscoile',
        'High School Transcripts': 'Tras-scríbhinní Meánscoile',
        'College & University Transcripts': 'Tras-scríbhinní Coláiste agus Ollscoile',
        'Certificate Maker': 'Déantóir Teastais',
        'International': 'Idirnáisiúnta',
        'View all International': 'Féach ar Gach Rud Idirnáisiúnta',
        'UK College/University Diplomas & Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste/Ollscoile na Ríochta Aontaithe',
        'Ireland College/University Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste/Ollscoile na hÉireann',
        'Canada College/University Diplomas & Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste/Ollscoile Cheanada',
        'Australia College/University Diplomas & Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste/Ollscoile na hAstráile',
        'India College/University Diplomas & Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste/Ollscoile na hIndia',
        'Malaysia College/University Diplomas & Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste/Ollscoile na Malaeisia',
        'France College & University Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste agus Ollscoile na Fraince',
        'Puerto Rico College & University Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste agus Ollscoile Phórtó Ríce',
        'Philippines College and University Diplomas and Transcript': 'Dioplómaí agus Tras-scríbhinní Coláiste agus Ollscoile na nOileán Filipíneach',
        'Africa College & University Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste agus Ollscoile na hAfraice',
        'Germany College & University Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste agus Ollscoile na Gearmáine',
        'Italy College & University Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste agus Ollscoile na hIodáile',
        'Mexico College & University Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Coláiste agus Ollscoile Mheicsiceo',
        'Other Country Diplomas and Transcripts': 'Dioplómaí agus Tras-scríbhinní Tíortha Eile',
        'Resources': 'Acmhainní',
        'View all Resources': 'Féach ar na hAcmhainní go léir',
        'Extras': 'Breiseanna',
        'Seals and Emblems': 'Séalaí agus Feathail',
        'Diploma Covers': 'Clúdaigh Dioplóma',
        'Upgrades': 'Uasghráduithe',
        'Reprints': 'Athphriontaí',
        'Contact Us': 'Déan Teagmháil Linn',
        'Order Status': 'Stádas Ordaithe',
        'FAQ': 'Ceisteanna Coitianta',
        'Reviews': 'Léirmheasanna',
        'Free Sample Request': 'Iarratas ar Shampla Saor in Aisce',
        'Custom Request': 'Iarratas Saincheaptha',
        'About Us': 'Fúinn',
        'Samples': 'Samplaí',
        'Giving Back': 'Ag Tabhairt Ar Ais',
        'Returns': 'Tuairisceáin',
        'Blog': 'Blag',
        'Terms of service': 'Téarmaí Seirbhíse',
        'Contact': 'Teagmháil',
        'Diploma, Transcript & Certificate Guide': 'Treoir Dioplómaí, Tras-scríbhinní agus Teastas',
        'FAQ Guide': 'Treoir Ceisteanna Coitianta',
        'Help': 'Cabhair',
        'Cart': 'Cairt',
        'Ireland College/ University Match Diploma': 'Dioplóma Meaitseála Coláiste/Ollscoile na hÉireann',
        'Hey Congrats International Order Assistant': 'Cúntóir Ordaithe Idirnáisiúnta Hey Congrats',
        'Step': 'Céim',
        'of': 'as',
        'Order total': 'Iomlán an ordaithe',
        'Current total': 'Iomlán reatha',
        'Back': 'Ar ais',
        'Continue': 'Lean ar aghaidh',
        'Review changes': 'Athbhreithnigh na hathruithe',
        'Add order to cart': 'Cuir an t-ordú sa chairt',
        'Adding your order…': 'D’ordú á chur leis…',
        'Edit': 'Cuir in eagar',
        'optional': 'roghnach',
        'No thanks': 'Níl, go raibh maith agat',
        'Please select one': 'Roghnaigh ceann amháin, le do thoil',
        'Choose a reference file': 'Roghnaigh comhad tagartha',
        'Choose a file': 'Roghnaigh comhad',
        'Replace selected file': 'Ionadaigh an comhad roghnaithe',
        'Remove': 'Bain',
        'I’ll guide you through each detail, then add the complete International document order to your cart.': 'Treoróidh mé thú trí gach sonra, ansin cuirfidh mé an t-ordú iomlán cáipéise idirnáisiúnta le do chairt.',
        'International document images': 'Íomhánna cáipéisí idirnáisiúnta',
        'Review every image carried over from this product’s previous form. These images are informational; select one to open a larger view.': 'Athbhreithnigh gach íomhá a tugadh anonn ó fhoirm roimhe seo an táirge. Tá na híomhánna seo mar eolas; roghnaigh ceann chun amharc níos mó a oscailt.',
        'Browse international document images': 'Brabhsáil íomhánna cáipéisí idirnáisiúnta',
        'Show previous international document images': 'Taispeáin na híomhánna cáipéisí idirnáisiúnta roimhe seo',
        'Show next international document images': 'Taispeáin na chéad íomhánna cáipéisí idirnáisiúnta eile',
        'Swipe left or right to see more images': 'Svaidhpeáil ar chlé nó ar dheis chun tuilleadh íomhánna a fheiceáil',
        'International product images': 'Íomhánna táirge idirnáisiúnta',
        'Why Customers Choose Hey Congrats': 'Cén Fáth a Roghnaíonn Custaiméirí Hey Congrats',
        'We Are Carbon Neutral!': 'Táimid Neodrach ó Thaobh Carbóin de!',
        'Guaranteed Delivery with UPS': 'Seachadadh Ráthaithe le UPS',
        'Buy Now Pay Later': 'Ceannaigh Anois, Íoc Níos Déanaí',
        'Live support: During Support Hours': 'Tacaíocht bheo: Le Linn Uaireanta Tacaíochta',
        'In business since 2001': 'I mbun gnó ó 2001',

        'How would you like to receive the document order?': 'Conas ba mhaith leat ordú na cáipéise a fháil?',
        'The price shown comes directly from the selected Shopify product variant.': 'Tagann an praghas a thaispeántar go díreach ón malairt táirge Shopify roghnaithe.',
        'Digital PDF': 'PDF digiteach',
        'Delivered electronically. Nothing is printed or shipped.': 'Seachadadh go leictreonach. Ní phriontáiltear ná ní sheoltar aon rud.',
        'Printed copy': 'Cóip chlóite',
        'Professionally printed paper copies mailed to you.': 'Cóipeanna páipéir priontáilte go gairmiúil agus seolta chugat sa phost.',
        'Digital PDF + printed copy': 'PDF digiteach + cóip chlóite',
        'Receive electronic files and mailed printed copies.': 'Faigh comhaid leictreonacha agus cóipeanna clóite sa phost.',
        'Shipping for mailed orders is calculated at checkout.': 'Ríomhtar an loingseoireacht d’orduithe poist ag an tseiceáil amach.',

        'Tell us about the school or institution.': 'Inis dúinn faoin scoil nó faoin institiúid.',
        'Enter the institution and authorization details.': 'Cuir isteach sonraí na hinstitiúide agus an údaraithe.',
        'College, university, or institution name': 'Ainm an choláiste, na hollscoile nó na hinstitiúide',
        'Country': 'Tír',
        'City, state, province, or region': 'Cathair, stát, cúige nó réigiún',
        'Institution address': 'Seoladh na hinstitiúide',
        'What authorizes this request?': 'Cad a údaraíonn an t-iarratas seo?',
        'Enter the name exactly as it should appear on the non-official display copy.': 'Cuir isteach an t-ainm díreach mar ba cheart dó a bheith ar an gcóip taispeána neamhoifigiúil.',
        'Enter the country associated with the institution.': 'Cuir isteach an tír a bhaineann leis an institiúid.',
        'Enter the location exactly as it should appear.': 'Cuir isteach an suíomh díreach mar ba cheart dó a bheith.',
        'Optional.': 'Roghnach.',
        'Select the statement that accurately describes your request.': 'Roghnaigh an ráiteas a chuireann síos go cruinn ar d’iarratas.',
        'The document represents my own earned record': 'Léiríonn an cháipéis mo thaifead féin a ghnóthaigh mé',
        'I have the recipient’s permission': 'Tá cead an fhaighteora agam',
        'I am authorized by the institution or issuer': 'Táim údaraithe ag an institiúid nó ag an eisitheoir',
        'This is a clearly fictional production prop': 'Fearas léiriúcháin atá go soiléir ficseanúil é seo',

        'Tell us about the recipient.': 'Inis dúinn faoin bhfaighteoir.',
        'Enter each detail exactly as it should appear.': 'Cuir isteach gach sonra díreach mar ba cheart dó a bheith.',
        'Recipient or student’s full name': 'Ainm iomlán an fhaighteora nó an mhic léinn',
        'Graduation or award date': 'Dáta bronnta céime nó dámhachtana',
        'Enter it exactly as it should appear.': 'Cuir isteach é díreach mar ba cheart dó a bheith.',
        'Enter the date that should appear.': 'Cuir isteach an dáta ba cheart a bheith le feiceáil.',

        'Add the diploma details.': 'Cuir sonraí na dioplóma leis.',
        'Use the qualification names and grading system appropriate to the country or institution.': 'Úsáid ainmneacha na gcáilíochtaí agus an córas grádaithe atá oiriúnach don tír nó don institiúid.',
        'Diploma, degree, or transcript title': 'Teideal na dioplóma, na céime nó na tras-scríbhinne',
        'Program, major, or field of study': 'Clár, príomhábhar nó réimse staidéir',
        'Language that should appear on the document': 'An teanga ba cheart a bheith ar an gcáipéis',
        'Exact wording in the original language': 'An fhoclaíocht bheacht sa bhunteanga',
        'English production explanation': 'Míniú táirgthe i mBéarla',
        'Document or transcript print / issue date': 'Dáta priontála / eisiúna na cáipéise nó na tras-scríbhinne',
        'Use the exact title or local qualification name requested for the non-official display copy.': 'Úsáid an teideal beacht nó ainm áitiúil na cáilíochta a iarrtar don chóip taispeána neamhoifigiúil.',
        'Enter the program or field exactly as it should appear.': 'Cuir isteach an clár nó an réimse díreach mar ba cheart dó a bheith.',
        'The production order remains organized with English field names.': 'Fanfaidh an t-ordú táirgthe eagraithe le hainmneacha réimsí i mBéarla.',
        'Optional. Enter any wording that must be copied exactly; we will not automatically translate or alter it.': 'Roghnach. Cuir isteach aon fhoclaíocht nach mór a chóipeáil go beacht; ní aistreoimid ná ní athróimid go huathoibríoch í.',
        'Explain the meaning of any non-English wording so the production team receives clear instructions in English.': 'Mínigh brí aon fhoclaíochta nach bhfuil i mBéarla ionas go bhfaighidh an fhoireann táirgthe treoracha soiléire i mBéarla.',
        'Enter the production date that should appear.': 'Cuir isteach an dáta táirgthe ba cheart a bheith le feiceáil.',

        'Would you like to provide a document or course reference?': 'Ar mhaith leat tagairt cháipéise nó chúrsa a chur ar fáil?',
        'Uploads are optional and will be attached to the Shopify order.': 'Tá uaslódálacha roghnach agus ceanglófar iad leis an ordú Shopify.',
        'Upload a diploma or document reference': 'Uaslódáil tagairt dioplóma nó cháipéise',
        'Optional. PDF, JPG, JPEG, PNG, HEIC or HEIF up to 20 MB. Do not upload government IDs, financial information, Social Security numbers, or other highly sensitive information.': 'Roghnach. PDF, JPG, JPEG, PNG, HEIC nó HEIF suas le 20 MB. Ná huaslódáil cártaí aitheantais rialtais, faisnéis airgeadais, uimhreacha Slándála Sóisialta ná faisnéis an-íogair eile.',
        'Finished document width': 'Leithead críochnaithe na cáipéise',
        'Finished document height': 'Airde chríochnaithe na cáipéise',
        'Measurement unit': 'Aonad tomhais',
        'Enter the exact finished width; do not estimate from the uploaded image.': 'Cuir isteach an leithead críochnaithe beacht; ná déan meastachán ón íomhá uaslódáilte.',
        'Enter the exact finished height; do not estimate from the uploaded image.': 'Cuir isteach an airde chríochnaithe bheacht; ná déan meastachán ón íomhá uaslódáilte.',
        'Inches': 'Orlaí',
        'Centimeters': 'Ceintiméadair',
        'Millimeters': 'Milliméadair',

        'Choose the finishing and proof details.': 'Roghnaigh sonraí an chríochnaithe agus an phromhaidh.',
        'Use only names, artwork, and references you are authorized to provide.': 'Ná húsáid ach ainmneacha, saothar ealaíne agus tagairtí a bhfuil cead agat iad a sholáthar.',
        'How should signature lines be handled?': 'Conas ba cheart déileáil le línte sínithe?',
        'Do not provide a real person’s name unless you are authorized to use it.': 'Ná tabhair ainm duine fíor mura bhfuil tú údaraithe é a úsáid.',
        'Leave signature lines blank': 'Fág na línte sínithe bán',
        'Use non-identifying sample signatures': 'Úsáid sínithe samplacha neamhaitheantais',
        'Use authorized signer names supplied below': 'Úsáid ainmneacha sínitheoirí údaraithe a sholáthraítear thíos',
        'Do not include signature lines': 'Ná cuir línte sínithe san áireamh',
        'Authorized signer names and titles': 'Ainmneacha agus teidil sínitheoirí údaraithe',
        'Required only when authorized names are selected.': 'Ní theastaíonn sé ach nuair a roghnaítear ainmneacha údaraithe.',
        'Decorative emblem treatment': 'Cóireáil na feathlaide maisiúla',
        'Use only authorized or generic decorative artwork. These choices do not create or reproduce security features.': 'Ná húsáid ach saothar ealaíne maisiúil údaraithe nó cineálach. Ní chruthaíonn ná ní atáirgeann na roghanna seo gnéithe slándála.',
        'Metallic decorative emblem': 'Feathal maisiúil miotalach',
        'Flat decorative emblem included': 'Feathal maisiúil cothrom san áireamh',
        'Included at no additional charge.': 'San áireamh gan aon táille bhreise.',
        'Metallic decorative elements in multiple places': 'Eilimintí maisiúla miotalacha in áiteanna éagsúla',
        'Review a proof before printing': 'Athbhreithnigh promhadh roimh phriontáil',
        'Our designers will email a mockup for review before the mailed copy is produced.': 'Seolfaidh ár ndearthóirí samhail chugat ar ríomhphost lena hathbhreithniú sula dtáirgtear an chóip poist.',
        'Where should we send the proof?': 'Cá háit ar cheart dúinn an promhadh a sheoladh?',

        'Choose applicable extras and confirm the intended use.': 'Roghnaigh na breiseanna cuí agus deimhnigh an úsáid atá beartaithe.',
        'Every paid selection uses a real Shopify add-on, and final production notes should be in English.': 'Úsáideann gach rogha íoctha breiseán fíor Shopify, agus ba cheart na nótaí táirgthe deiridh a bheith i mBéarla.',
        'Additional diploma copies': 'Cóipeanna breise dioplóma',
        'Copies use the same approved personalized design.': 'Úsáideann na cóipeanna an dearadh pearsantaithe ceadaithe céanna.',
        '1 extra diploma copy': '1 chóip bhreise dioplóma',
        '2 extra diploma copies': '2 chóip bhreise dioplóma',
        'No extra diploma copies': 'Gan aon chóipeanna breise dioplóma',
        'Diploma presentation folder': 'Fillteán cur i láthair dioplóma',
        'Choose an optional hardback leatherette folder.': 'Roghnaigh fillteán roghnach crua le bailchríoch leathair bhréige.',
        'College Graduate cover': 'Clúdach céimí coláiste',
        'Custom school-name cover': 'Clúdach saincheaptha le hainm na scoile',
        'Which cover color would you like?': 'Cén dath clúdaigh ba mhaith leat?',
        'What text should appear on the custom cover?': 'Cén téacs ba cheart a bheith ar an gclúdach saincheaptha?',
        "Add the graduate's name to the cover": 'Cuir ainm an chéimí leis an gclúdach',
        'Black': 'Dubh',
        'Navy blue': 'Gorm dúghorm',
        'Red': 'Dearg',
        'Green': 'Glas',
        'Maroon': 'Marún',
        'How will this personalized copy be used?': 'Conas a úsáidfear an chóip phearsantaithe seo?',
        'Select the permitted, non-official use.': 'Roghnaigh an úsáid cheadaithe, neamhoifigiúil.',
        'Personal display or framing': 'Taispeáint phearsanta nó frámaíocht',
        'Personal replacement or backup of an earned record': 'Athsholáthar pearsanta nó cúltaca de thaifead a gnóthaíodh',
        'Authorized gift or keepsake': 'Bronntanas nó cuimhneachán údaraithe',
        'Clearly fictional production prop': 'Fearas léiriúcháin atá go soiléir ficseanúil',
        'Other permitted non-official display use': 'Úsáid taispeána neamhoifigiúil cheadaithe eile',
        'Anything else should our production team know?': 'An bhfuil aon rud eile ba cheart don fhoireann táirgthe a bheith ar eolas acu?',
        'Optional. Provide production instructions in English.': 'Roghnach. Tabhair treoracha táirgthe i mBéarla.',

        'Let’s review everything.': 'Déanaimis gach rud a athbhreithniú.',
        'Check the spelling, selections, permissions, uploads, and total before adding the order to your cart.': 'Seiceáil an litriú, na roghanna, na ceadanna, na huaslódálacha agus an t-iomlán sula gcuirfidh tú an t-ordú le do chairt.',
        'Delivery': 'Seachadadh',
        'Document': 'Cáipéis',
        'Paid extras': 'Breiseanna íoctha',
        'Ireland': 'Éire',
        'Irish': 'Gaeilge',
        'Read the full Hey Congrats disclaimer': 'Léigh séanadh iomlán Hey Congrats',
        'Institution Name': 'Ainm na hinstitiúide',
        'Institution Country': 'Tír na hinstitiúide',
        'Institution Location': 'Suíomh na hinstitiúide',
        'Institution Address': 'Seoladh na hinstitiúide',
        'Authorization Basis': 'Bunús an údaraithe',
        'Recipient Name': 'Ainm an fhaighteora',
        'Graduation or Award Date': 'Dáta bronnta céime nó dámhachtana',
        'Document Title': 'Teideal na cáipéise',
        'Program or Major': 'Clár nó príomhábhar',
        'Requested Document Language': 'Teanga iarrtha na cáipéise',
        'Exact Wording — Original Language': 'Foclaíocht bheacht — an bhunteanga',
        'English Translation or Production Explanation': 'Aistriúchán Béarla nó míniú táirgthe',
        'Print / Issue Date': 'Dáta priontála / eisiúna',
        'Diploma or Document Reference File': 'Comhad tagartha dioplóma nó cáipéise',
        'Finished Document Width': 'Leithead críochnaithe na cáipéise',
        'Finished Document Height': 'Airde chríochnaithe na cáipéise',
        'Finished Document Size Unit': 'Aonad méide na cáipéise críochnaithe',
        'Signature Treatment': 'Cóireáil sínithe',
        'Authorized Signer Names and Titles': 'Ainmneacha agus teidil sínitheoirí údaraithe',
        'Decorative Emblem Treatment': 'Cóireáil na feathlaide maisiúla',
        'Proof Review': 'Athbhreithniú promhaidh',
        'Best Email and Cell Phone for Proofing': 'An ríomhphost agus an fón póca is fearr don phromhadh',
        'Extra Diploma Copies': 'Cóipeanna breise dioplóma',
        'Diploma Cover': 'Clúdach dioplóma',
        'Cover Color': 'Dath an chlúdaigh',
        'Custom Cover Text': 'Téacs saincheaptha an chlúdaigh',
        'Diploma Cover - Add Graduate Name': 'Clúdach dioplóma — cuir ainm an chéimí leis',
        'Intended Use': 'Úsáid bheartaithe',
        'Notes and Special Instructions': 'Nótaí agus treoracha speisialta',
        'I confirm that I earned or am authorized to request this personalized, non-official display copy; that I have permission to use submitted names, logos, artwork, and references; and that it will not be used as an official record, proof of education, employment or licensing evidence, or to misrepresent credentials.': 'Deimhním gur ghnóthaigh mé an taifead seo nó go bhfuilim údaraithe an chóip taispeána phearsantaithe neamhoifigiúil seo a iarraidh; go bhfuil cead agam na hainmneacha, na lógónna, an saothar ealaíne agus na tagairtí a cuireadh isteach a úsáid; agus nach n-úsáidfear í mar thaifead oifigiúil, mar chruthúnas ar oideachas, mar fhianaise fostaíochta nó cheadúnaithe, ná chun cáilíochtaí a mhíléiriú.',

        'Institution name': 'Ainm na hinstitiúide',
        'City, region, country': 'Cathair, réigiún, tír',
        'Street address and postal code': 'Seoladh sráide agus cód poist',
        'Full name': 'Ainm iomlán',
        'Example: Bachelor of Arts': 'Sampla: Baitsiléir Ealaíon',
        'Program or field of study': 'Clár nó réimse staidéir',
        'Example: English, French, Spanish': 'Sampla: Béarla, Fraincis, Spáinnis',
        'Exact original-language wording': 'Foclaíocht bheacht sa bhunteanga',
        'English explanation of the requested wording': 'Míniú i mBéarla ar an bhfoclaíocht iarrtha',
        'Example: 8.5 or 210': 'Sampla: 8.5 nó 210',
        'Example: 11 or 297': 'Sampla: 11 nó 297',
        'Name — title; Name — title': 'Ainm — teideal; Ainm — teideal',
        'Enter the school name or cover wording': 'Cuir isteach ainm na scoile nó foclaíocht an chlúdaigh',
        'Optional production notes': 'Nótaí táirgthe roghnacha',

        'Please complete': 'Comhlánaigh',
        'to continue.': 'chun leanúint ar aghaidh.',
        'Choose how you would like to receive the document order.': 'Roghnaigh conas ba mhaith leat ordú na cáipéise a fháil.',
        'Accept the intended-use agreement before adding the order to your cart.': 'Glac leis an gcomhaontú úsáide beartaithe sula gcuirfidh tú an t-ordú le do chairt.',
        'That delivery option is not currently available.': 'Níl an rogha seachadta sin ar fáil faoi láthair.',
        'Shopify could not add this order to the cart. Please try again.': 'Níorbh fhéidir le Shopify an t-ordú seo a chur leis an gcairt. Bain triail eile as.',
        'One or more selections did not reach the cart. Nothing was added; please try again.': 'Níor shroich rogha amháin nó níos mó an chairt. Níor cuireadh aon rud leis; bain triail eile as.'
      }
    }
  };

  const sharedInternationalLanguagePacks = window.HCInternationalLanguagePacks || {};
  Object.entries(sharedInternationalLanguagePacks.products || {}).forEach(([handle, route]) => {
    const [profileKey, title] = route;
    const profile = sharedInternationalLanguagePacks.profiles?.[profileKey];
    if (!profile) return;
    internationalLanguagePilots[handle] = {
      ...profile,
      title,
      translations: { ...(profile.translations || {}) }
    };
  });

  const resourcePlainText = (value) => String(value ?? '')
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const resourceOptionName = (option, index) => {
    const name = resourcePlainText(option?.name);
    if (/delivery options/i.test(name)) return 'Document type';
    return name || `Product option ${index + 1}`;
  };

  const resourceOptionLines = (values) => values.map((item) => [
    item.value,
    item.label || item.value,
    item.help || '',
    item.image || ''
  ].join(' | ')).join('\n');

  const resourceChoiceBlock = (key, label, values, settings = {}) => ({
    id: key,
    type: 'choice_field',
    step: settings.step || 'customization',
    key,
    label,
    propertyName: settings.propertyName || label,
    help: settings.help || '',
    required: settings.required !== false,
    defaultValue: settings.defaultValue || '',
    options: resourceOptionLines(values),
    showFor: 'all',
    group: key,
    control: settings.control || (values.length > 8 ? 'select' : 'buttons'),
    ...(Number.isInteger(settings.variantOptionIndex)
      ? { variantOptionIndex: settings.variantOptionIndex }
      : {}),
    ...(settings.conditionKey ? {
      conditionKey: settings.conditionKey,
      conditionValue: settings.conditionValue,
      conditionOperator: settings.conditionOperator || 'equals'
    } : {}),
    ...(settings.hidden ? { hidden: true, storeProperty: false } : {})
  });

  const resourceTextBlock = (key, label, settings = {}) => ({
    id: key,
    type: 'text_field',
    step: settings.step || 'order',
    key,
    label,
    propertyName: settings.propertyName || label,
    help: settings.help || '',
    placeholder: settings.placeholder || '',
    required: settings.required !== false,
    inputType: settings.inputType || 'text',
    defaultValue: '',
    showFor: 'all',
    group: key,
    control: 'toggle',
    ...(settings.conditionKey ? {
      conditionKey: settings.conditionKey,
      conditionValue: settings.conditionValue,
      conditionOperator: settings.conditionOperator || 'equals'
    } : {})
  });

  const resourceFileBlock = (key, label, settings = {}) => ({
    id: key,
    type: 'file_field',
    step: settings.step || 'reference',
    key,
    label,
    propertyName: settings.propertyName || label,
    help: settings.help || '',
    required: settings.required === true,
    accept: settings.accept || '*/*',
    maxFileSizeMb: settings.maxFileSizeMb || 20,
    showFor: 'all',
    group: key,
    control: 'toggle',
    ...(settings.conditionKey ? {
      conditionKey: settings.conditionKey,
      conditionValue: settings.conditionValue,
      conditionOperator: settings.conditionOperator || 'equals'
    } : {})
  });

  const resourceVariantBlocks = (config, skipIndexes = new Set()) =>
    (config.product.options || []).flatMap((option, index) => {
      if (skipIndexes.has(index)) return [];
      const values = (option.values || []).map((value) => ({ value, label: value }));
      if (!values.length) return [];
      const hidden = values.length === 1 && String(values[0].value).toLowerCase() === 'default title';
      const optionName = resourceOptionName(option, index);
      return [resourceChoiceBlock(
        `resource_variant_option_${index}`,
        optionName,
        values,
        {
          step: 'selection',
          propertyName: optionName,
          defaultValue: hidden ? values[0].value : '',
          variantOptionIndex: index,
          control: values.length > 8 ? 'select' : 'buttons',
          hidden
        }
      )];
    });

  const resourceLinkedAddon = (
    config,
    fieldKey,
    fieldValue,
    price,
    propertyName,
    product = config.assistantUpgrades,
    variantTitle = `$${price} Selected Upgrade`
  ) => {
    return {
      id: `${fieldKey}_paid_${price}`,
      type: 'linked_addon',
      step: 'customization',
      key: `${fieldKey}_paid_${price}`,
      label: propertyName,
      propertyName,
      group: `${fieldKey}_paid_${price}`,
      linkedFieldKey: fieldKey,
      linkedFieldValue: fieldValue,
      variantTitle,
      product
    };
  };

  const resourceExactHelper = (handle, variantId, title = 'Default Title') => ({
    handle,
    title: handle,
    variants: [{ id: variantId, title, price: 1000, available: true }]
  });

  const buildCoverBlocks = (config) => {
    const handle = config.product.handle;
    const engravedHandles = new Set([
      'diploma-of-graduation-engraved-cover',
      'home-school-diploma-engraved-cover',
      'home-school-graduate-engraved-cover',
      'high-school-diploma-engraved-cover',
      'college-graduate-engraved-cover',
      'general-education-diploma-engraved-cover',
      'high-school-equivalency-engraved-cover',
      'certificate-of-appreciation-engraved-cover',
      'certificate-of-completion-engraved-cover',
      'thank-you-engraved-cover',
      'birth-certificate-engraved-cover',
      'certificate-of-marriage-engraved-cover'
    ]);
    const exactColorValues = ['Black', 'Navy Blue', 'Red', 'Green', 'Maroon']
      .map((value) => ({ value, label: value }));
    const addExactColorImages = (blocks) => {
      const colorBlock = blocks.find((block) =>
        Number.isInteger(block.variantOptionIndex) && /color/i.test(block.label)
      );
      if (colorBlock) colorBlock.options = resourceOptionLines(exactColorValues);
      return blocks;
    };

    if (handle === 'blank-covers') {
      return addExactColorImages(resourceVariantBlocks(config));
    }

    if (handle === 'custom-logo-and-text-printed-cover') {
      const customizationKey = 'custom_cover_customization';
      const textAndName = 'Add Text & Student Name (+$10)';
      const logoAndName = 'Add Logo & Student Name (+$10)';
      return [
        ...addExactColorImages(resourceVariantBlocks(config)),
        resourceChoiceBlock('custom_cover_foil', 'Printed Metallic Foil Color', [
          { value: 'Gold' }, { value: 'Silver' }
        ]),
        resourceChoiceBlock('custom_cover_orientation', 'Orientation', [
          { value: 'Horizontal/Landscape' }, { value: 'Vertical/Portrait' }
        ]),
        resourceChoiceBlock(customizationKey, 'Customization', [
          { value: 'Add Logo' },
          { value: 'Add Text' },
          { value: textAndName, help: 'Adds $10.00 per cover.' },
          { value: logoAndName, help: 'Adds $10.00 per cover.' }
        ]),
        resourceTextBlock('custom_cover_center_text', 'Center Text', {
          step: 'customization',
          conditionKey: customizationKey,
          conditionValue: 'Text',
          conditionOperator: 'contains'
        }),
        resourceTextBlock('custom_cover_student_name', 'Student Name', {
          step: 'customization',
          conditionKey: customizationKey,
          conditionValue: 'Name',
          conditionOperator: 'contains'
        }),
        resourceFileBlock('custom_cover_logo', 'Logo Upload', {
          step: 'customization',
          required: true,
          accept: '*/*',
          conditionKey: customizationKey,
          conditionValue: 'Logo',
          conditionOperator: 'contains'
        }),
        resourceLinkedAddon(
          config,
          customizationKey,
          textAndName,
          10,
          'Customization'
        ),
        resourceLinkedAddon(
          config,
          customizationKey,
          logoAndName,
          10,
          'Customization'
        )
      ];
    }

    if (!engravedHandles.has(handle)) return resourceVariantBlocks(config);

    const customizationKey = 'engraved_cover_customization';
    const addName = 'Add Name (+ $10)';
    return [
      ...resourceVariantBlocks(config),
      resourceChoiceBlock('engraved_cover_size', 'Size', [
        { value: '8 x 6' },
        { value: '8.5 x 11' },
        { value: '8.3 x 11.7 (A4)' },
        { value: '11 x 14' }
      ], { step: 'selection' }),
      resourceChoiceBlock('engraved_cover_color', 'Cover Color', exactColorValues, {
        step: 'selection'
      }),
      resourceChoiceBlock('engraved_cover_foil', 'Printed Metallic Foil Color', [
        { value: 'Gold' }, { value: 'Silver' }
      ]),
      resourceChoiceBlock('engraved_cover_orientation', 'Orientation', [
        { value: 'Horizontal/Landscape' },
        { value: 'Vertical/Portrait' }
      ], { propertyName: 'Printing Orientation' }),
      resourceChoiceBlock(customizationKey, 'Customization', [
        { value: 'No Thanks' },
        { value: addName, help: 'Adds $10.00 per cover.' }
      ]),
      resourceTextBlock('engraved_cover_student_name', 'Student Name', {
        step: 'customization',
        conditionKey: customizationKey,
        conditionValue: 'Name',
        conditionOperator: 'contains'
      }),
      resourceLinkedAddon(
        config,
        customizationKey,
        addName,
        10,
        'Customization',
        resourceExactHelper(
          'diploma-engraved-cover-add-student-name-10',
          42561169752109
        ),
        ''
      )
    ];
  };

  const applyResourceProfile = (config) => {
    const profile = config.resourceProfile || 'cover';
    const handle = config.product.handle;
    config.designEnabled = false;
    config.defaultDesign = config.product.title;
    config.showDesignPreview = false;
    config.showProductImageOnDelivery = false;
    config._resourceProfile = profile;
    config._resourceQuantityEnabled = ['cover', 'state_seal', 'reprint'].includes(profile);
    config.labels.reviewDesign = 'Product';
    config.labels.variantError = 'That product-option combination is not currently available.';

    if (profile === 'cover') {
      config.forceDeliveryType = 'print';
      config.blocks = buildCoverBlocks(config);
      config.steps.forEach((step) => {
        if (step.id === 'selection') {
          if (handle === 'custom-logo-and-text-printed-cover') {
            step.title = 'Choose the custom cover color and size.';
            step.subtitle = 'This repaired, review-required form binds directly to the current Shopify cover variants.';
          } else if (handle === 'blank-covers') {
            step.title = 'Choose the blank cover color and size.';
            step.subtitle = 'Choose directly from the native Shopify size and color variants.';
          } else {
            step.title = 'Choose the engraved cover color and size.';
            step.subtitle = 'These choices match the currently active engraved-cover form.';
          }
        }
        if (step.id === 'customization') {
          step.title = handle === 'custom-logo-and-text-printed-cover'
            ? 'Add the cover artwork, text, and finishing details.'
            : 'Add the cover personalization and finishing details.';
          step.subtitle = handle === 'custom-logo-and-text-printed-cover'
            ? 'This repaired profile requires review before activation because the currently published rule is orphaned.'
            : 'Required choices and conditional fields match the currently active engraved-cover form.';
        }
      });
    } else if (profile === 'order_upgrade') {
      config.blocks = [
        ...resourceVariantBlocks(config),
        resourceTextBlock('original_order_number', 'Original order number', {
          placeholder: 'Example: HC1234 or #1234'
        }),
        resourceTextBlock('original_order_email', 'Email used on the original order', {
          inputType: 'email', placeholder: 'name@example.com'
        }),
        resourceTextBlock('original_order_name', 'Name on the original order', {
          required: false, placeholder: 'Optional if the order number and email are provided'
        }),
        resourceTextBlock('upgrade_instructions', 'Which document or order item should this apply to?', {
          inputType: 'textarea',
          placeholder: 'Tell us exactly which diploma, transcript, shipment, or document should receive this upgrade.'
        })
      ];
      if (/email-version|email-delivery/.test(handle)) config.forceDeliveryType = 'digital';
      else config.forceDeliveryType = 'print';
      config.steps.forEach((step) => {
        if (step.id === 'selection') {
          step.title = 'Choose the upgrade option.';
          step.subtitle = 'These are the exact options and prices attached to this Shopify product.';
        }
        if (step.id === 'order') {
          step.title = 'Tell us which existing order to update.';
          step.subtitle = 'The order number and checkout email let our team match this purchase correctly.';
        }
      });
    } else if (profile === 'reprint') {
      config.blocks = [
        ...resourceVariantBlocks(config),
        resourceTextBlock('original_order_number', 'Original order number', {
          placeholder: 'Example: HC1234 or #1234'
        }),
        resourceTextBlock('original_order_email', 'Email used on the original order', {
          inputType: 'email', placeholder: 'name@example.com'
        }),
        resourceTextBlock('recipient_name', 'Student or recipient name on the document', {
          placeholder: 'Enter it exactly as it appeared on the original order'
        }),
        resourceTextBlock('requested_changes', 'List every requested change', {
          step: 'reference',
          inputType: 'textarea',
          required: handle.includes('with-changes'),
          placeholder: handle.includes('with-changes')
            ? 'List each exact change from the original order.'
            : 'Leave blank when the reprint should be identical.'
        }),
        resourceFileBlock('reprint_reference_file', 'Upload a reference for the reprint', {
          step: 'reference', required: false
        }),
        resourceTextBlock('reprint_notes', 'Additional reprint instructions', {
          step: 'reference', inputType: 'textarea', required: false
        })
      ];
      config.steps.forEach((step) => {
        if (step.id === 'selection') {
          step.title = 'Choose the reprint type.';
          step.subtitle = 'The exact Shopify option determines the document set and price.';
        }
        if (step.id === 'order') {
          step.title = 'Find the original order.';
          step.subtitle = 'Enter the original order details so we reproduce the correct document.';
        }
        if (step.id === 'reference') {
          step.title = handle.includes('with-changes')
            ? 'Tell us exactly what needs to change.'
            : 'Add an optional reference or note.';
          step.subtitle = 'Uploads are attached to the Shopify cart line for our production team.';
        }
      });
    } else if (profile === 'state_seal') {
      config.forceDeliveryType = 'print';
      config.blocks = resourceVariantBlocks(config);
      config.steps.forEach((step) => {
        if (step.id === 'selection') {
          step.title = 'Choose the state seal.';
          step.subtitle = 'Select the state from the complete Shopify variant list.';
        }
      });
    } else if (profile === 'custom_design') {
      config.forceDeliveryType = 'digital';
      config.blocks = [
        ...resourceVariantBlocks(config),
        resourceTextBlock('contact_email', 'Contact email', {
          step: 'customization', inputType: 'email', placeholder: 'name@example.com'
        }),
        resourceTextBlock('project_title', 'Project or document name', {
          step: 'customization', placeholder: 'What should we call this project?'
        }),
        resourceTextBlock('design_instructions', 'Describe the design you want made', {
          step: 'customization', inputType: 'textarea'
        }),
        resourceFileBlock('design_reference_file', 'Upload the design or reference file', {
          step: 'reference', required: true
        }),
        resourceTextBlock('design_notes', 'Additional production notes', {
          step: 'reference', inputType: 'textarea', required: false
        })
      ];
    } else {
      config.blocks = resourceVariantBlocks(config);
    }

    config.steps = config.steps.filter((step) => {
      if (step.id === 'review') return true;
      if (step.id === 'selection') {
        return config._resourceQuantityEnabled ||
          config.blocks.some((block) => block.step === 'selection' && !block.hidden);
      }
      return config.blocks.some((block) => block.step === step.id && !block.hidden);
    });
    return config;
  };

  const applyProductSpecificCopy = (config) => {
    const handle = config.product?.handle;

    if (resourceIsActive(config)) return applyResourceProfile(config);

    if (String(config.version || '').startsWith('match-native')) {
      config.blocks
        .filter((block) => block.type === 'file_field')
        .forEach((block) => {
          block.required = false;
          block.help = String(block.help || '')
            .replace(/^Required for Match products\.\s*/i, 'Optional. ')
            .replace(/^Required for Match transcripts\.\s*/i, 'Optional. ');
        });
    }

    const stateDiplomaHandle = 'high-school-diplomas-by-state';
    const statePackageHandle = 'high-school-diploma-and-transcripts-by-state';
    const stockHighSchoolPackageHandle = 'stock-high-school-diploma-and-transcript-package';
    const highSchoolPackageHandles = new Set([stockHighSchoolPackageHandle, statePackageHandle]);
    const stateHandles = new Set([stateDiplomaHandle, statePackageHandle]);
    const collegeStockDiplomaHandle = 'college-and-university-diploma-degree-usa-stock-design';
    const collegeStockPackageHandle = 'college-university-stock-diploma-and-stock-transcripts-usa';
    const highSchoolMatchHandle = 'high-school-match-diploma-from-your-example';
    const collegePropMatchHandle = 'college-university-prop-match-usa-diploma';
    const collegeMatchPackageHandle = 'college-university-match-diploma-degree-match-transcripts-usa';
    const collegeMatchStockPackageHandle = 'college-and-university-match-diploma-degree-stock-transcripts-usa';
    const collegeMatchTranscriptsHandle = 'college-university-match-transcripts';
    const collegeStockTranscriptsHandle = 'college-university-stock-transcripts-usa';
    const secondaryDocumentHandles = new Set([
      'secondary-school-canada-diplomas',
      'spanish-secondary-certificate'
    ]);

    if (String(config.version || '').startsWith('international-native')) {
      const profile = config.formProfile || 'M';
      const includesDiploma = ['M', 'PS', 'PM'].includes(profile);
      const includesTranscript = ['PS', 'PM', 'TM', 'TS'].includes(profile);
      const matchesDiploma = ['M', 'PS', 'PM'].includes(profile);
      const matchesTranscript = ['PM', 'TM'].includes(profile);
      const defaultCountries = {
        'canada-college-university-prop-diploma': 'Canada',
        'college-and-university-match-diploma-from-africa': '',
        'uk-college-and-university-match-diplomas': 'United Kingdom',
        'college-and-university-match-diploma-from-puerto-rico': 'Puerto Rico',
        'canada-college-university-match-diploma-and-stock-transcripts': 'Canada',
        'uk-college-university-match-diploma-and-match-transcript-package': 'United Kingdom',
        'college-and-university-match-diplomas-from-india': 'India',
        'college-and-university-match-diploma-from-turkey': 'Turkey',
        'college-and-university-match-diploma-degree-from-uae': 'United Arab Emirates',
        'faux-diplomes-universitaires-diplomes-et-certificats-france': 'France',
        'diplomi-di-laurea-in-college-e-universita-falsi-in-italia': 'Italy',
        'college-and-university-match-diploma-from-spain': 'Spain',
        'college-and-university-match-diploma-degrees-from-germany': 'Germany',
        'college-and-university-match-diplomas-from-malaysia': 'Malaysia',
        'college-and-university-match-diploma-from-argentina': 'Argentina',
        'college-and-university-match-diplomas-from-singapore': 'Singapore',
        'college-and-university-match-diploma-from-philippines': 'Philippines',
        'college-and-university-match-diploma-from-brazil': 'Brazil',
        'college-and-university-match-diploma-from-panama': 'Panama',
        'college-and-university-diploma-degrees-in-new-zealand': 'New Zealand',
        'college-and-university-match-diploma-from-albania': 'Albania',
        'college-and-university-match-diploma-from-mexico': 'Mexico',
        'malaysia-college-university-match-diploma-stock-transcript-package': 'Malaysia',
        'malaysia-college-university-stock-transcripts': 'Malaysia',
        'malaysia-college-university-match-diplomas': 'Malaysia',
        'australia-college-university-diploma-and-transcript-package': 'Australia',
        'australia-college-university-diploma': 'Australia',
        'india-college-university-match-diploma-and-stock-transcript-package': 'India',
        'india-college-university-stock-transcripts': 'India',
        'india-college-university-match-diploma': 'India',
        'canada-college-university-transcripts': 'Canada',
        'uk-college-university-transcript': 'United Kingdom',
        'any-countrys-university-match-transcripts': '',
        'australia-college-university-transcripts': 'Australia',
        'canada-college-university-match-diploma-and-match-transcripts': 'Canada',
        'canada-college-university-match-transcript': 'Canada',
        'ireland-college-university-match-diploma': 'Ireland'
      };

      config.designEnabled = false;
      config.defaultDesign = config.product.title;
      config.deliveryOptionIndex = 0;
      config.showDesignPreview = false;
      config.showProductImageOnDelivery = false;
      config.labels.deliveryDigital = includesDiploma && includesTranscript ? 'Digital documents' : 'Digital PDF';
      config.labels.deliveryDigitalHelp = 'Delivered electronically. Nothing is printed or shipped.';
      config.labels.deliveryPrint = includesDiploma && includesTranscript ? 'Printed document set' : 'Printed copy';
      config.labels.deliveryPrintHelp = 'Professionally printed paper copies mailed to you.';
      config.labels.deliveryBoth = includesDiploma && includesTranscript ? 'Digital documents + printed set' : 'Digital PDF + printed copy';
      config.labels.deliveryBothHelp = 'Receive electronic files and mailed printed copies.';
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the document order.';
      config.labels.variantError = 'That delivery and page-count combination is not currently available.';

      const allowedKeys = new Set([
        'institution_name', 'institution_country', 'institution_location', 'institution_address',
        'authorization_basis', 'recipient_name', 'graduation_date', 'document_title', 'program_major',
        'document_language', 'original_wording', 'english_explanation', 'issue_date', 'signatures',
        'signer_names', 'intended_use', 'production_notes'
      ]);
      if (includesDiploma) {
        ['reference_file', 'finished_width', 'finished_height', 'size_unit', 'seal_metallic',
          'seal_multiple', 'diploma_copy_1', 'diploma_copy_2', 'cover_college', 'cover_custom',
          'cover_color', 'custom_cover_text', 'cover_name'].forEach((key) => allowedKeys.add(key));
      }
      if (includesTranscript) {
        ['student_id', 'date_of_birth', 'gpa', 'issued_to_student', 'transcript_pages',
          'course_file', 'course_submit', 'course_custom', 'transcript_copy_1',
          'transcript_copy_2'].forEach((key) => allowedKeys.add(key));
      }
      if (profile === 'PS' || profile === 'TS') {
        allowedKeys.add('school_colors');
        allowedKeys.add('logo_file');
      }
      if (matchesTranscript) allowedKeys.add('transcript_reference_file');
      if (profile !== 'TS') {
        allowedKeys.add('proof');
        allowedKeys.add('proof_contact');
      }
      config.blocks = config.blocks.filter((block) => allowedKeys.has(block.key));

      const countryBlock = config.blocks.find((block) => block.key === 'institution_country');
      if (countryBlock && Object.prototype.hasOwnProperty.call(defaultCountries, handle)) {
        countryBlock.defaultValue = defaultCountries[handle];
      }
      const locationBlock = config.blocks.find((block) => block.key === 'institution_location');
      if (locationBlock && defaultCountries[handle] === 'Canada') {
        locationBlock.label = 'City and province';
        locationBlock.propertyName = 'Institution City and Province';
        locationBlock.placeholder = 'Example: Toronto, Ontario';
      }

      const secondOptionValues = unique(config.product.variants
        .map((variant) => variant.options[1])
        .filter(Boolean));
      if (secondOptionValues.length) {
        config.blocks.unshift({
          id: 'pages_included',
          type: 'choice_field',
          step: 'delivery',
          key: 'pages_included',
          label: 'How many transcript pages should be included?',
          propertyName: 'Pages Included',
          help: 'The total updates to the exact Shopify variant price.',
          required: true,
          inputType: 'text',
          defaultValue: secondOptionValues[0],
          options: secondOptionValues.map((value) => `${value} | ${value}`).join('\n'),
          showFor: 'all',
          group: 'pages_included',
          control: 'buttons',
          variantOptionIndex: 1
        });
      }

      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = secondOptionValues.length
            ? 'Choose the delivery method and number of transcript pages.'
            : 'How would you like to receive the document order?';
          step.subtitle = secondOptionValues.length
            ? 'The total comes from the exact delivery-and-page-count Shopify variant.'
            : 'The price shown comes directly from the selected Shopify product variant.';
        }
        if (step.id === 'school') {
          step.title = 'Tell us about the school or institution.';
          step.subtitle = 'Enter the institution and authorization details.';
        }
        if (step.id === 'graduate') {
          step.title = 'Tell us about the recipient.';
          step.subtitle = 'Enter each detail exactly as it should appear.';
        }
        if (step.id === 'academic') {
          step.title = includesTranscript ? 'Add the document and transcript details.' : 'Add the diploma details.';
          step.subtitle = 'Use the qualification names and grading system appropriate to the country or institution.';
        }
        if (step.id === 'reference') {
          step.title = matchesTranscript && matchesDiploma
            ? 'Provide any diploma, transcript, or course references.'
            : matchesTranscript
              ? 'Provide any transcript or course references.'
              : 'Would you like to provide a document or course reference?';
          step.subtitle = 'Uploads are optional and will be attached to the Shopify order.';
        }
        if (step.id === 'finishing') {
          step.title = 'Choose the finishing and proof details.';
          step.subtitle = 'Use only names, artwork, and references you are authorized to provide.';
        }
        if (step.id === 'extras') {
          step.title = 'Choose applicable extras and confirm the intended use.';
          step.subtitle = 'Every paid selection uses a real Shopify add-on, and final production notes should be in English.';
        }
      });

      config.steps = config.steps.filter((step) =>
        step.id === 'delivery' || step.id === 'review' || config.blocks.some((block) => block.step === step.id)
      );
      config.languagePilot = internationalLanguagePilots[handle] || null;
      config._internationalDelivery = true;
      config._internationalProfile = profile;
      return config;
    }

    const certificateHandles = new Set([
      'certificate-of-personal-training-1',
      'certificate-of-personal-training',
      'bartending-certificates',
      'certificate-of-achievement',
      'life-coach',
      'certificate-of-appreciation-thanks-for-college',
      'certificate-tesol-teaching-english-to-speakers-of-other-languages',
      'certificate-tafe-certificate-iii-australia',
      'buy-certificates-and-qualifications-in-usa-of-all-kinds',
      'buy-certificates-qualifications-from-uk-of-all-kinds',
      'buy-certificates-qualifications-global-of-all-kinds',
      'certificate-property-manager',
      'tafe-certificate-iii-with-transcript-bundle-australia',
      'certificate-of-authenticity',
      'certificate-of-appreciation-thank-you-for-your-support',
      'certificate-abe-business-executive',
      'certificate-dpsi-diploma-in-public-service-interpreting',
      'certificate-goalkeeping-coach',
      'certificate-six-sigma-green-belt',
      'certificate-cambridge-esol-entry-level',
      'certificate-match-a-certificate-from-your-scan',
      'certificate-scottish-qualifications-authority',
      'certificate-gce-general-certificate-of-secondary-education',
      'certificate-prop-red-seal-canada',
      'certificate-cieh-chartered-instiute-of-environmental-health',
      'certificate-fetac',
      'tafe-certificate-iii-transcript-australia',
      'buy-culinary-certificates'
    ]);
    const certificateDesignDeliveryHandles = new Set([
      'certificate-of-personal-training',
      'bartending-certificates'
    ]);
    const certificateDesignOnlyHandles = new Set(['life-coach']);
    const certificateFixedPrintedHandles = new Set([
      'life-coach',
      'certificate-of-appreciation-thanks-for-college',
      'certificate-of-appreciation-thank-you-for-your-support',
      'certificate-of-authenticity'
    ]);

    if (certificateHandles.has(handle)) {
      const certificateName = config.product.title || 'custom certificate';
      config.showDesignPreview = false;
      config.showProductImageOnDelivery = false;

      if (certificateDesignDeliveryHandles.has(handle)) {
        config.designEnabled = true;
        config.designOptionIndex = 0;
        config.deliveryOptionIndex = 1;
        config.steps.unshift({
          id: 'design',
          title: 'Choose the certificate design.',
          subtitle: 'Select a design. Every previous product image remains available in the gallery above.'
        });
      } else if (certificateDesignOnlyHandles.has(handle)) {
        config.designEnabled = true;
        config.designOptionIndex = 0;
        config.deliveryOptionIndex = 0;
        config.deliveryUsesDesign = true;
        config.forceDeliveryType = 'print';
        config.steps = config.steps.filter((step) => step.id !== 'delivery');
        config.steps.unshift({
          id: 'design',
          title: 'Choose the certificate design.',
          subtitle: 'Select the design that should be personalized.'
        });
      } else {
        config.designEnabled = false;
        config.defaultDesign = certificateName;
        config.deliveryOptionIndex = 0;
      }

      if (certificateFixedPrintedHandles.has(handle)) {
        config.forceDeliveryType = 'print';
      }

      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = 'How would you like to receive the certificate?';
          step.subtitle = 'Choose the available Shopify delivery option. The displayed price comes from the exact variant.';
        }
        if (step.id === 'school') {
          step.title = 'Who is issuing this certificate?';
          step.subtitle = 'The issuer must be you or an organization you are authorized to represent.';
        }
        if (step.id === 'graduate') {
          step.title = 'Who is receiving the certificate?';
          step.subtitle = 'Enter the recipient details exactly as they should appear.';
        }
        if (step.id === 'academic') {
          step.title = 'What should the certificate recognize?';
          step.subtitle = 'Use this for appreciation, participation, milestones, volunteer service, events, celebrations, gifts, internal non-licensed training, or a clearly fictional prop.';
        }
        if (step.id === 'reference') {
          step.title = 'Would you like to provide a logo or reference?';
          step.subtitle = 'Optional. Upload only artwork or references you have permission to use.';
        }
        if (step.id === 'finishing') {
          step.title = 'Choose the finishing details.';
          step.subtitle = 'Tell us how to handle signatures, seals, and other display details.';
        }
        if (step.id === 'extras') {
          step.title = 'Paid proof review and special instructions.';
          step.subtitle = 'Add paid proof review when offered and include any final notes for the design team.';
        }
      });

      config.labels.deliveryDigital = 'Digital PDF';
      config.labels.deliveryDigitalHelp = 'Delivered electronically. Nothing is printed or shipped.';
      config.labels.deliveryPrint = 'Printed certificate';
      config.labels.deliveryPrintHelp = 'A professionally printed certificate mailed to you.';
      config.labels.deliveryBoth = 'Digital PDF + printed certificate';
      config.labels.deliveryBothHelp = 'Receive the electronic file and a mailed printed certificate.';
      config.labels.reviewDesign = 'Certificate design';
      config.labels.chooseDesignError = 'Choose a certificate design to continue.';
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the certificate.';
      config.labels.variantError = 'That certificate design and delivery combination is not currently available.';
      config.labels.terms = 'I confirm that I am the issuer or am authorized by the issuing organization, that I have permission to use submitted names, logos, and artwork, and that this certificate will not be presented as an official license, regulated credential, academic qualification, or proof of professional authorization.';
      return config;
    }

    if (handle === 'high-school-transcripts' || handle === 'high-school-equivalency-score-transcript') {
      const isHseScores = handle === 'high-school-equivalency-score-transcript';
      const documentName = isHseScores ? 'high school equivalency score transcript' : 'high school transcript';
      config.designEnabled = false;
      config.defaultDesign = config.product.title;
      config.deliveryOptionIndex = 0;
      config.showDesignPreview = true;
      config.showProductImageOnDelivery = true;
      config.steps = config.steps.filter((step) => step.id !== 'design');
      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = `How would you like to receive the ${documentName}?`;
          step.subtitle = 'Choose a digital PDF, a printed copy, or both.';
        }
        if (step.id === 'details') {
          step.title = isHseScores
            ? 'Enter the testing center and student information.'
            : 'Enter the school and student information.';
          step.subtitle = 'Please enter each detail exactly as it should appear.';
        }
        if (step.id === 'finishing') {
          step.title = isHseScores ? 'Add the High School Equivalency score details.' : 'Add the transcript details.';
          step.subtitle = 'Complete the dates, academic details, and finishing choices.';
        }
        if (step.id === 'extras') {
          step.title = 'Would you like to add anything?';
          step.subtitle = 'Optional printed-order upgrades use real Shopify add-on products.';
        }
      });
      config.labels.deliveryDigital = 'Digital PDF';
      config.labels.deliveryDigitalHelp = 'Delivered electronically. Nothing is printed or shipped.';
      config.labels.deliveryPrint = 'Printed copy';
      config.labels.deliveryPrintHelp = `A professionally printed ${documentName} mailed to you.`;
      config.labels.deliveryBoth = 'Digital PDF + printed copy';
      config.labels.deliveryBothHelp = 'Receive the electronic file and a mailed printed copy.';
      config.labels.chooseDeliveryError = `Choose how you would like to receive the ${documentName}.`;
      config.labels.variantError = 'That delivery option is not currently available.';
      config.labels.terms = 'I agree this product is for novelty, replacement, or display purposes and will not be used to misrepresent education or credentials.';
      return config;
    }

    if (secondaryDocumentHandles.has(handle)) {
      const isSpanish = handle === 'spanish-secondary-certificate';
      const documentName = isSpanish ? 'Spanish secondary certificate' : 'Canadian secondary school diploma';
      config.designEnabled = false;
      config.defaultDesign = config.product.title;
      config.deliveryOptionIndex = 0;
      config.steps = config.steps.filter((step) => step.id !== 'design');
      config.blocks = config.blocks.filter((block) =>
        block.key !== 'seal_treatment' && !String(block.key).startsWith('folder_')
      );
      const blockCopy = {
        testing_center: {
          label: 'What is the secondary school name?',
          propertyName: 'School Name',
          placeholder: 'Secondary school name'
        },
        award_location: {
          label: 'Where is the secondary school located?',
          propertyName: 'School Location',
          help: isSpanish ? 'Enter the city, region, and country.' : 'Enter the city and province.',
          placeholder: isSpanish ? 'Example: Madrid, Spain' : 'Example: Toronto, Ontario'
        },
        graduate_name: {
          label: 'What is the graduate’s full name?',
          propertyName: "Graduate's Name",
          help: 'Enter it exactly as it should appear on the document.',
          placeholder: 'Graduate’s full name'
        },
        completion_date: {
          label: 'What completion or graduation date should we print?',
          propertyName: 'Completion Date'
        }
      };
      config.blocks.forEach((block) => {
        if (blockCopy[block.key]) Object.assign(block, blockCopy[block.key]);
      });
      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = `How would you like to receive the ${documentName}?`;
          step.subtitle = 'Choose a digital PDF, a printed copy, or both.';
        }
        if (step.id === 'details') {
          step.title = `Tell me what should appear on the ${documentName}.`;
          step.subtitle = 'Enter the school and graduate information exactly as it should appear.';
        }
        if (step.id === 'finishing') {
          step.title = 'Add the completion details.';
          step.subtitle = 'Choose the date and how the signature lines should be handled.';
        }
        if (step.id === 'extras') {
          step.title = 'Would you like to add paid proof review?';
          step.subtitle = 'Paid proof choices appear for eligible mailed orders, and their prices come directly from Shopify.';
        }
      });
      config.labels.deliveryDigital = 'Digital PDF';
      config.labels.deliveryDigitalHelp = 'Delivered electronically. Nothing is printed or shipped.';
      config.labels.deliveryPrint = 'Printed copy';
      config.labels.deliveryPrintHelp = `A professionally printed ${documentName} mailed to you.`;
      config.labels.deliveryBoth = 'Digital PDF + printed copy';
      config.labels.deliveryBothHelp = 'Receive the electronic file and a mailed printed copy.';
      config.labels.chooseDeliveryError = `Choose how you would like to receive the ${documentName}.`;
      config.labels.variantError = 'That delivery option is not currently available.';
      return config;
    }

    if (handle === highSchoolMatchHandle) {
      config.steps = config.steps.filter((step) => step.id !== 'academic');
      config.blocks = config.blocks.filter((block) =>
        block.step !== 'academic' && !['student_id', 'date_of_birth'].includes(block.key)
      );
      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = 'How would you like to receive your matched high school diploma?';
          step.subtitle = 'Choose a digital PDF, a printed copy, or both.';
        }
        if (step.id === 'reference') {
          step.title = 'Upload the high school diploma we should match.';
          step.subtitle = 'A clear scan or photo helps our design team follow the original layout.';
        }
      });
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the matched high school diploma.';
      return config;
    }

    if (handle === collegePropMatchHandle) {
      config.deliveryOptionIndex = 0;
      config.blocks = config.blocks.filter((block) =>
        !['student_id', 'date_of_birth', 'gpa', 'course_submit', 'course_custom', 'transcript_courses'].includes(block.key)
      );
      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = 'How would you like to receive your matched college diploma?';
          step.subtitle = 'Choose a digital PDF, a printed copy, or both.';
        }
        if (step.id === 'reference') {
          step.title = 'Upload the college or university diploma we should match.';
          step.subtitle = 'A clear scan or photo helps our design team follow the original layout.';
        }
      });
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the matched college diploma.';
      return config;
    }

    if (handle === collegeMatchPackageHandle) {
      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = 'How would you like to receive the matched diploma and transcript?';
          step.subtitle = 'Choose digital PDFs, printed copies, or both.';
        }
        if (step.id === 'reference') {
          step.title = 'Upload the college or university documents we should match.';
          step.subtitle = 'Clear scans or photos help our design team follow the original layouts.';
        }
      });
      config.labels.deliveryDigital = 'Digital PDFs';
      config.labels.deliveryDigitalHelp = 'Both documents delivered electronically. Nothing is printed or shipped.';
      config.labels.deliveryPrint = 'Printed diploma + transcript';
      config.labels.deliveryPrintHelp = 'A professionally printed diploma and transcript mailed to you.';
      config.labels.deliveryBoth = 'Digital PDFs + printed diploma and transcript';
      config.labels.deliveryBothHelp = 'Receive electronic files and mailed printed copies of both documents.';
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the matched diploma and transcript.';
      return config;
    }

    if (handle === collegeMatchStockPackageHandle) {
      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = 'How would you like to receive the matched diploma and stock transcripts?';
          step.subtitle = 'Choose digital files, printed copies, or both.';
        }
        if (step.id === 'reference') {
          step.title = 'Upload the college or university diploma we should match.';
          step.subtitle = 'A clear scan or photo helps our design team follow the diploma layout; the transcripts use our coordinated stock format.';
        }
      });
      const referenceBlock = config.blocks.find((block) => block.key === 'reference_file');
      if (referenceBlock) {
        referenceBlock.label = 'Upload the diploma reference we should match';
        referenceBlock.propertyName = 'Diploma Reference File';
      }
      config.labels.deliveryDigital = 'Digital diploma + transcripts';
      config.labels.deliveryDigitalHelp = 'All documents delivered electronically. Nothing is printed or shipped.';
      config.labels.deliveryPrint = 'Printed diploma + transcripts';
      config.labels.deliveryPrintHelp = 'A professionally printed diploma and stock transcript set mailed to you.';
      config.labels.deliveryBoth = 'Digital files + printed set';
      config.labels.deliveryBothHelp = 'Receive electronic files and a mailed printed diploma and transcript set.';
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the diploma and stock transcripts.';
      return config;
    }

    if (handle === collegeMatchTranscriptsHandle || handle === collegeStockTranscriptsHandle) {
      const isMatch = handle === collegeMatchTranscriptsHandle;
      config.designEnabled = false;
      config.defaultDesign = config.product.title;
      config.deliveryOptionIndex = 0;
      const allowedSteps = isMatch
        ? new Set(['delivery', 'school', 'graduate', 'academic', 'reference', 'finishing', 'review'])
        : new Set(['delivery', 'school', 'graduate', 'academic', 'finishing', 'review']);
      config.steps = config.steps.filter((step) => allowedSteps.has(step.id));
      const allowedBlocks = new Set([
        'school_name', 'school_location', 'school_address', 'graduate_name', 'student_id',
        'graduation_date', 'date_of_birth', 'degree', 'major', 'gpa', 'issue_date',
        'signatures', 'design_notes', ...(isMatch ? ['reference_file', 'transcript_courses'] : ['course_submit', 'course_custom'])
      ]);
      config.blocks = config.blocks.filter((block) => allowedBlocks.has(block.key));
      const notesBlock = config.blocks.find((block) => block.key === 'design_notes');
      if (notesBlock) {
        notesBlock.step = 'finishing';
        notesBlock.label = 'Notes and special instructions:';
      }
      if (isMatch) {
        const pageValues = unique(config.product.variants
          .map((variant) => variant.options[1])
          .filter(Boolean));
        config.blocks.unshift({
          id: 'pages_included',
          type: 'choice_field',
          step: 'delivery',
          key: 'pages_included',
          label: 'How many transcript pages should be included?',
          propertyName: 'Pages Included',
          help: 'The order total updates to the exact Shopify variant price.',
          required: true,
          inputType: 'text',
          defaultValue: pageValues[0] || '',
          options: pageValues.map((value) => `${value} | ${value}`).join('\n'),
          showFor: 'all',
          group: 'pages_included',
          control: 'buttons',
          variantOptionIndex: 1
        });
        const referenceBlock = config.blocks.find((block) => block.key === 'reference_file');
        if (referenceBlock) {
          referenceBlock.label = 'Upload the transcript reference we should match';
          referenceBlock.propertyName = 'Transcript Reference File';
          referenceBlock.help = 'Optional. Upload a clear PDF, JPG, JPEG, PNG, HEIC or HEIF up to 20 MB. Do not upload Social Security numbers, government identification, financial information or other highly sensitive information.';
        }
      }
      config.steps.forEach((step) => {
        if (step.id === 'delivery') {
          step.title = isMatch
            ? 'Choose the delivery method and number of transcript pages.'
            : 'How would you like to receive the stock transcripts?';
          step.subtitle = isMatch
            ? 'The total comes from the exact delivery-and-page-count Shopify variant.'
            : 'Choose digital PDFs, printed copies, or both.';
        }
        if (step.id === 'school') {
          step.title = 'Tell us about the college or university.';
          step.subtitle = 'Enter the school information exactly as it should appear on the transcripts.';
        }
        if (step.id === 'graduate') {
          step.title = 'Tell us about the student.';
          step.subtitle = 'Enter the student and graduation details exactly as they should appear.';
        }
        if (step.id === 'academic') {
          step.title = 'Add the transcript details.';
          step.subtitle = 'Choose the degree, major, GPA, and issue date used on the transcript.';
        }
        if (step.id === 'reference') {
          step.title = 'Upload the transcript we should match.';
          step.subtitle = 'A clear reference helps our design team follow the original layout.';
        }
        if (step.id === 'finishing') {
          step.title = 'Choose signatures and add any notes.';
          step.subtitle = 'We use professional in-house sample signatures or can leave the signature area blank.';
        }
      });
      config.labels.deliveryDigital = 'Digital PDF';
      config.labels.deliveryDigitalHelp = 'Delivered electronically. Nothing is printed or shipped.';
      config.labels.deliveryPrint = 'Printed transcripts';
      config.labels.deliveryPrintHelp = 'Professionally printed transcript pages mailed to you.';
      config.labels.deliveryBoth = 'Digital PDF + printed transcripts';
      config.labels.deliveryBothHelp = 'Receive electronic files and mailed printed transcript pages.';
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the transcripts.';
      return config;
    }

    if (stateHandles.has(handle)) {
      config.excludeDesignValues = ['Choose Your State'];
      config.steps.forEach((step) => {
        if (step.id === 'design') {
          step.title = 'Which state should the high school documents represent?';
          step.subtitle = 'Choose the state whose design details should be used.';
        }
      });
      config.labels.reviewDesign = 'State';
      config.labels.gallery = 'State diploma design gallery';
      config.labels.chooseDesignError = 'Choose a state to continue.';
    }

    if (handle === stateDiplomaHandle) {
      const stateDiplomaBlockCopy = {
        school_name: {
          label: 'What is the high school name?',
          placeholder: 'High school name'
        },
        school_location: {
          label: 'Where is the high school located?',
          placeholder: 'Example: Richmond, Virginia'
        },
        student_name: {
          label: 'What is the graduate’s full name?',
          propertyName: "Graduate's Name",
          placeholder: 'Graduate’s full name'
        },
        seal_note: {
          label: 'State seal treatment',
          help: 'The selected state design determines the seal and layout details.'
        }
      };
      config.blocks.forEach((block) => {
        if (stateDiplomaBlockCopy[block.key]) Object.assign(block, stateDiplomaBlockCopy[block.key]);
      });
      config.steps.forEach((step) => {
        if (step.id === 'delivery') step.title = 'How would you like to receive the state high school diploma?';
        if (step.id === 'details') step.title = 'Tell me what should appear on the state high school diploma.';
      });
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the state high school diploma.';
      return config;
    }

    if (handle === collegeStockDiplomaHandle || handle === collegeStockPackageHandle) {
      const collegeBlockCopy = {
        testing_center: {
          label: 'What is the college or university name?',
          propertyName: 'College or University Name',
          placeholder: 'College or university name'
        },
        award_location: {
          label: 'Where is the college or university located?',
          propertyName: 'College or University Location',
          help: 'Enter the city and state, or country.',
          placeholder: 'Example: Richmond, Virginia'
        },
        score_range: {
          label: 'Which GPA range would you prefer?',
          propertyName: 'Preferred GPA Range',
          help: 'Our designers will assign appropriate grades within the selected range.'
        }
      };
      config.blocks.forEach((block) => {
        if (collegeBlockCopy[block.key]) Object.assign(block, collegeBlockCopy[block.key]);
      });
      const graduateIndex = Math.max(0, config.blocks.findIndex((block) => block.key === 'graduate_name') + 1);
      config.blocks.splice(graduateIndex, 0,
        {
          id: 'degree',
          type: 'choice_field',
          step: 'details',
          key: 'degree',
          label: 'Which degree should appear on the documents?',
          propertyName: 'Degree',
          help: '',
          required: true,
          inputType: 'text',
          defaultValue: '',
          options: collegeDegreeOptions,
          showFor: 'all',
          group: 'degree',
          control: 'select'
        },
        {
          id: 'major',
          type: 'text_field',
          step: 'details',
          key: 'major',
          label: 'What is the major or field of study?',
          propertyName: 'Major',
          help: '',
          placeholder: 'Major or field of study',
          required: true,
          inputType: 'text',
          defaultValue: '',
          showFor: 'all',
          group: 'major',
          control: 'toggle'
        }
      );
      config.blocks = config.blocks.filter((block) => !String(block.key).startsWith('folder_'));
      config.steps.forEach((step) => {
        if (step.id === 'design') {
          step.title = handle === collegeStockPackageHandle
            ? 'Which college diploma and transcript design do you like?'
            : 'Which college diploma design do you like?';
          step.subtitle = 'Choose one of the five coordinated stock styles.';
        }
        if (step.id === 'delivery') {
          step.title = handle === collegeStockPackageHandle
            ? 'How would you like to receive the diploma and transcript?'
            : 'How would you like to receive the college diploma?';
        }
        if (step.id === 'details') {
          step.title = 'Tell me what should appear on the college documents.';
          step.subtitle = 'Enter the school, graduate, degree, and major exactly as they should appear.';
        }
        if (step.id === 'finishing' && handle === collegeStockPackageHandle) {
          step.title = 'Add the college transcript details.';
          step.subtitle = 'Complete the information used on the coordinated transcript.';
        }
      });
      config.labels.gallery = handle === collegeStockPackageHandle
        ? 'College diploma and transcript design gallery'
        : 'College diploma design gallery';
      if (handle === collegeStockPackageHandle) {
        config.labels.deliveryDigital = 'Digital PDFs';
        config.labels.deliveryDigitalHelp = 'Both documents delivered electronically. Nothing is printed or shipped.';
        config.labels.deliveryPrint = 'Printed diploma + transcript';
        config.labels.deliveryPrintHelp = 'A professionally printed college diploma and transcript mailed to you.';
        config.labels.deliveryBoth = 'Digital PDFs + printed diploma and transcript';
        config.labels.deliveryBothHelp = 'Receive electronic files and mailed printed copies of both documents.';
      } else {
        config.labels.deliveryDigital = 'Digital PDF';
        config.labels.deliveryDigitalHelp = 'Delivered electronically. Nothing is printed or shipped.';
        config.labels.deliveryPrint = 'Printed college diploma';
        config.labels.deliveryPrintHelp = 'A professionally printed college diploma mailed to you.';
        config.labels.deliveryBoth = 'Digital PDF + printed college diploma';
        config.labels.deliveryBothHelp = 'Receive the electronic file and a mailed printed college diploma.';
      }
      config.labels.chooseDesignError = 'Choose a college document design to continue.';
      config.labels.chooseDeliveryError = 'Choose how you would like to receive the college documents.';
      return config;
    }

    if (!highSchoolPackageHandles.has(handle)) return config;

    const stepCopy = {
      design: {
        title: 'Which high school diploma and transcript design do you like?',
        subtitle: 'Choose one of the five coordinated document styles.'
      },
      delivery: {
        title: 'How would you like to receive the diploma and transcript?',
        subtitle: 'Choose digital PDFs, printed paper copies, or both.'
      },
      details: {
        title: 'Tell me what should appear on both documents.',
        subtitle: 'Enter the school and graduate information exactly as you want it printed.'
      },
      finishing: {
        title: 'Add the high school transcript details.',
        subtitle: 'Complete the information used on the coordinated transcript.'
      }
    };

    config.steps.forEach((step) => {
      if (stepCopy[step.id]) Object.assign(step, stepCopy[step.id]);
    });

    if (handle === statePackageHandle) {
      const designStep = config.steps.find((step) => step.id === 'design');
      if (designStep) {
        designStep.title = 'Which state should the high school diploma and transcript represent?';
        designStep.subtitle = 'Choose the state whose coordinated document details should be used.';
      }
    }

    const blockCopy = {
      testing_center: {
        label: 'What is the high school name?',
        propertyName: 'School Name',
        placeholder: 'High school name'
      },
      award_location: {
        label: 'Where is the high school located?',
        propertyName: 'School Location',
        help: 'Enter the city and state, or country.',
        placeholder: 'Example: Richmond, Virginia'
      },
      score_range: {
        label: 'Which grade range would you prefer?',
        propertyName: 'Preferred Grade Range',
        help: 'Our designers will assign appropriate grades within the selected range.'
      }
    };

    config.blocks.forEach((block) => {
      if (blockCopy[block.key]) Object.assign(block, blockCopy[block.key]);
    });

    if (handle === stockHighSchoolPackageHandle) {
      config.labels.gallery = 'High school diploma and transcript design gallery';
      config.labels.chooseDesignError = 'Choose a high school diploma and transcript design to continue.';
    }
    config.labels.chooseDeliveryError = 'Choose how you would like to receive the diploma and transcript.';
    config.labels.terms = 'I understand these are personalized, non-official display copies and cannot verify education, replace an official transcript, or be submitted as official credentials.';
    return config;
  };

  class HCOrderBuilder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mounted === 'true') return;
      this.dataset.mounted = 'true';

      try {
        this.config = applyProductSpecificCopy(
          JSON.parse(this.querySelector('[data-hc-config]').textContent)
        );
        this.config.labels = {
          currentTotal: 'Current total',
          reviewChanges: 'Review changes',
          edit: 'Edit',
          chooseFile: 'Choose a file',
          replaceFile: 'Replace selected file',
          removeFile: 'Remove',
          fileTooLargeError: 'That file is larger than [size] MB. Please choose a smaller file.',
          ...this.config.labels
        };
        this.state = {
          step: 0,
          layout: '',
          delivery: '',
          quantity: 1,
          fields: {},
          files: {},
          addons: {},
          accepted: false,
          editingReview: false,
          viewLanguage:
            this.config.languagePilot &&
            String(this.config.locale || '').toLowerCase().startsWith(
              String(this.config.languagePilot.locale || '').toLowerCase()
            )
              ? this.config.languagePilot.translatedLanguage
              : 'English',
          busy: false,
          error: ''
        };
        this.config.blocks.forEach((block) => {
          if (block.type === 'text_field' || block.type === 'choice_field') {
            this.state.fields[block.key] = block.defaultValue || '';
          } else if (block.type === 'file_field') {
            this.state.files[block.key] = null;
          }
        });
        if (!this.hasDesignStep) {
          this.state.layout = this.config.defaultDesign || this.config.product.title || 'Match Design';
        }
        if (this.config.deliveryUsesDesign && this.state.layout) {
          this.state.delivery = this.state.layout;
        }
        this.render();
      } catch (error) {
        this.showFatalError();
      }
    }

    get steps() {
      return this.config.steps;
    }

    get productVariants() {
      return this.config.product.variants || [];
    }

    get hasDesignStep() {
      return this.config.designEnabled !== false;
    }

    get designOptionIndex() {
      return Number.isInteger(this.config.designOptionIndex)
        ? this.config.designOptionIndex
        : 0;
    }

    get deliveryOptionIndex() {
      return Number.isInteger(this.config.deliveryOptionIndex)
        ? this.config.deliveryOptionIndex
        : (this.hasDesignStep ? 1 : 0);
    }

    get reviewStepIndex() {
      return Math.max(0, this.steps.findIndex((step) => step.id === 'review'));
    }

    get orderQuantity() {
      if (!resourceIsActive(this.config) || !this.config._resourceQuantityEnabled) return 1;
      return Math.max(1, Number(this.state.quantity) || 1);
    }

    get languagePilotIsActive() {
      return Boolean(this.config.languagePilot);
    }

    get translatedViewIsActive() {
      return this.languagePilotIsActive &&
        this.state.viewLanguage === this.config.languagePilot.translatedLanguage;
    }

    renderLanguageToggle() {
      return '';
    }

    applySectionLanguage() {
      if (!this.languagePilotIsActive) return;
      const section = this.closest('[data-hc-product-section]');
      if (!section) return;
      const pilot = this.config.languagePilot;
      const translations = pilot.translations || {};
      const switcher = section.querySelector('[data-hc-language-switcher]');
      if (switcher) {
        switcher.hidden = false;
        const translatedButton = switcher.querySelector('[data-hc-language-target]');
        if (translatedButton) translatedButton.dataset.hcLanguage = pilot.translatedLanguage;
      }
      section.querySelectorAll('[data-hc-language]').forEach((button) => {
        const isActive = button.dataset.hcLanguage === this.state.viewLanguage;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
        button.textContent = button.dataset.hcLanguage === pilot.translatedLanguage
          ? pilot.translatedButton
          : pilot.englishButton;
      });
      section.querySelectorAll('[data-hc-i18n-text]').forEach((element) => {
        if (!element.dataset.hcI18nOriginal) element.dataset.hcI18nOriginal = element.textContent.trim();
        const original = element.dataset.hcI18nOriginal;
        const translated = element.matches('h1.hcob-product-title') && pilot.title
          ? pilot.title
          : (translations[original] || original);
        element.textContent = this.translatedViewIsActive ? translated : original;
      });
      section.querySelectorAll('[data-hc-i18n-aria-label]').forEach((element) => {
        if (!element.dataset.hcI18nOriginalAria) {
          element.dataset.hcI18nOriginalAria = element.getAttribute('aria-label') || '';
        }
        const original = element.dataset.hcI18nOriginalAria;
        element.setAttribute('aria-label', this.translatedViewIsActive ? (translations[original] || original) : original);
      });
      section.setAttribute('lang', this.translatedViewIsActive ? (pilot.locale || 'ga') : 'en');
      section.setAttribute('dir', this.translatedViewIsActive ? (pilot.direction || 'ltr') : 'ltr');
    }

    applyHeaderLanguage() {
      if (!this.languagePilotIsActive) return;
      const pilot = this.config.languagePilot;
      const translations = pilot.translations || {};
      const translated = this.translatedViewIsActive;
      const translateValue = (value) => {
        const source = String(value ?? '');
        const trimmed = source.trim();
        let replacement = translations[trimmed];
        if (!replacement && pilot.cartAriaTemplate) {
          const cartMatch = trimmed.match(/^Open cart with (\d+) items?$/);
          if (cartMatch) replacement = pilot.cartAriaTemplate.replace('[count]', cartMatch[1]);
        }
        return replacement ? source.replace(trimmed, replacement) : source;
      };
      document.querySelectorAll('.utility-bar, .site-header').forEach((root) => {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        let textNode = walker.nextNode();
        while (textNode) {
          if (!languageOriginalText.has(textNode)) languageOriginalText.set(textNode, textNode.nodeValue);
          const original = languageOriginalText.get(textNode);
          textNode.nodeValue = translated ? translateValue(original) : original;
          textNode = walker.nextNode();
        }
        root.querySelectorAll('[aria-label]').forEach((element) => {
          if (!languageOriginalAttributes.has(element)) {
            languageOriginalAttributes.set(element, element.getAttribute('aria-label') || '');
          }
          const original = languageOriginalAttributes.get(element);
          element.setAttribute('aria-label', translated ? translateValue(original) : original);
        });
      });
      document.documentElement.setAttribute('lang', translated ? (pilot.locale || 'ga') : 'en');
    }

    applyVisibleLanguage() {
      this.applySectionLanguage();
      if (!this.translatedViewIsActive) return;
      const card = this.querySelector('.hcob-card');
      if (!card) return;
      const translations = this.config.languagePilot.translations || {};
      const entries = Object.entries(translations).sort((a, b) => b[0].length - a[0].length);
      const translate = (value) => {
        const source = String(value ?? '');
        const trimmed = source.trim();
        if (translations[trimmed]) return source.replace(trimmed, translations[trimmed]);
        const stepMatch = trimmed.match(/^Step (\d+) of (\d+)$/);
        if (stepMatch) {
          const stepLabel = translations.Step || 'Step';
          const ofLabel = translations.of || 'of';
          return source.replace(trimmed, `${stepLabel} ${stepMatch[1]} ${ofLabel} ${stepMatch[2]}`);
        }
        const safePartialEntries = entries.filter(([english]) => english.length >= 12);
        return safePartialEntries.reduce(
          (translated, [english, irish]) => translated.split(english).join(irish),
          source
        );
      };
      const walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();
      while (textNode) {
        textNode.nodeValue = translate(textNode.nodeValue);
        textNode = walker.nextNode();
      }
      card.querySelectorAll('[placeholder]').forEach((element) => {
        element.placeholder = translate(element.placeholder);
      });
      card.querySelectorAll('[aria-label]').forEach((element) => {
        element.setAttribute('aria-label', translate(element.getAttribute('aria-label')));
      });
      card.setAttribute('lang', this.config.languagePilot.locale || 'ga');
      card.setAttribute('dir', this.config.languagePilot.direction || 'ltr');
    }

    get layouts() {
      if (!this.hasDesignStep) {
        return [this.state.layout || this.config.defaultDesign || this.config.product.title];
      }
      return unique(this.productVariants
        .map((variant) => variant.options[this.designOptionIndex])
        .filter(Boolean))
        .filter((value) => !(this.config.excludeDesignValues || []).includes(value));
    }

    get deliveries() {
      return unique(this.productVariants
        .map((variant) => variant.options[this.deliveryOptionIndex])
        .filter(Boolean));
    }

    get selectedVariant() {
      return this.productVariants.find((variant) => {
        if (resourceIsActive(this.config)) {
          return variant.available !== false && this.config.blocks
            .filter((block) => Number.isInteger(block.variantOptionIndex))
            .every((block) =>
              variant.options[block.variantOptionIndex] === this.state.fields[block.key]
            );
        }
        const deliveryMatches =
          variant.options[this.deliveryOptionIndex] === this.state.delivery;
        const configuredOptionsMatch = this.config.blocks
          .filter((block) => Number.isInteger(block.variantOptionIndex))
          .every((block) =>
            variant.options[block.variantOptionIndex] === this.state.fields[block.key]
          );
        if (!this.hasDesignStep) return deliveryMatches && configuredOptionsMatch;
        return deliveryMatches && configuredOptionsMatch &&
          variant.options[this.designOptionIndex] === this.state.layout;
      });
    }

    get isDigitalOnly() {
      const value = String(this.state.delivery || '').toLowerCase();
      const explicitDigitalOnly =
        value.includes('not printed') ||
        value.includes('no product printed') ||
        value.includes('digital download only') ||
        value.includes('email digital copy') && !value.includes(' and mail') && !value.includes(' mailed');
      if (explicitDigitalOnly) return true;
      const hasDigital = value.includes('digital') || value.includes('email');
      const hasPhysical =
        value.includes('print') ||
        /\bmail(?:ed)?\b/.test(value) ||
        value.includes('hardcopy') ||
        value.includes('hard copy');
      return hasDigital && (
        value.includes('only') ||
        value.includes('no product') ||
        !hasPhysical
      );
    }

    money(cents) {
      return new Intl.NumberFormat(this.config.locale, {
        style: 'currency',
        currency: this.config.currency
      }).format((Number(cents) || 0) / 100);
    }

    deliveryCopy(value) {
      if (this.config.forceDeliveryType === 'print') {
        return { label: this.config.labels.deliveryPrint, help: this.config.labels.deliveryPrintHelp };
      }
      if (this.config.forceDeliveryType === 'both') {
        return { label: this.config.labels.deliveryBoth, help: this.config.labels.deliveryBothHelp };
      }
      if (this.config.forceDeliveryType === 'digital') {
        return { label: this.config.labels.deliveryDigital, help: this.config.labels.deliveryDigitalHelp };
      }
      const lower = String(value).toLowerCase();
      const explicitDigitalOnly =
        lower.includes('not printed') ||
        lower.includes('no product printed') ||
        lower.includes('digital download only') ||
        lower.includes('email digital copy') && !lower.includes(' and mail') && !lower.includes(' mailed');
      if (explicitDigitalOnly) {
        return {
          label: this.config.labels.deliveryDigital,
          help: this.config.labels.deliveryDigitalHelp
        };
      }
      const hasDigital = lower.includes('digital') || lower.includes('email');
      const hasPhysical =
        lower.includes('print') ||
        /\bmail(?:ed)?\b/.test(lower) ||
        lower.includes('hardcopy') ||
        lower.includes('hard copy');
      if (hasDigital && (
        lower.includes('only') ||
        lower.includes('no product') ||
        !hasPhysical
      )) {
        return {
          label: this.config.labels.deliveryDigital,
          help: this.config.labels.deliveryDigitalHelp
        };
      }
      if ((hasDigital && hasPhysical) || lower.includes('digital copy and')) {
        return {
          label: this.config.labels.deliveryBoth,
          help: this.config.labels.deliveryBothHelp
        };
      }
      if (hasPhysical) {
        return {
          label: this.config.labels.deliveryPrint,
          help: this.config.labels.deliveryPrintHelp
        };
      }
      return {
        label: this.config.labels.deliveryDigital,
        help: this.config.labels.deliveryDigitalHelp
      };
    }

    variantForDelivery(delivery) {
      return this.productVariants.find((variant) => {
        const deliveryMatches = variant.options[this.deliveryOptionIndex] === delivery;
        const configuredOptionsMatch = this.config.blocks
          .filter((block) => Number.isInteger(block.variantOptionIndex))
          .every((block) =>
            variant.options[block.variantOptionIndex] === this.state.fields[block.key]
          );
        if (!this.hasDesignStep) return deliveryMatches && configuredOptionsMatch;
        return deliveryMatches && configuredOptionsMatch &&
          variant.options[this.designOptionIndex] === (this.state.layout || this.layouts[0]);
      });
    }

    parseChoices(value) {
      return String(value || '')
        .split('\n')
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => {
          const [optionValue, label, help, image] = line.split('|').map((part) => part.trim());
          return {
            value: optionValue,
            label: label || optionValue,
            help: help || '',
            image: image || ''
          };
        });
    }

    visibleBlock(block) {
      if (block.showFor === 'mailed' && this.isDigitalOnly) return false;
      if (block.showFor === 'digital' && !this.isDigitalOnly) return false;
      if (!block.conditionKey) return true;

      const fieldValue = this.state.fields[block.conditionKey];
      const addonValue = this.state.addons[block.conditionKey];
      const actual = fieldValue !== undefined ? fieldValue : addonValue;

      if (block.conditionValue === 'selected') return Boolean(actual);
      if (block.conditionValue === 'not_selected') return !actual;
      if (block.conditionOperator === 'contains') {
        return String(actual ?? '').includes(String(block.conditionValue || ''));
      }
      return String(actual ?? '') === String(block.conditionValue);
    }

    blocksForStep(stepId) {
      return this.config.blocks.filter((block) =>
        block.step === stepId && !block.hidden && this.visibleBlock(block)
      );
    }

    addonVariants(block) {
      return (block.product?.variants || []).filter((variant) =>
        !block.variantTitle || String(variant.title) === String(block.variantTitle)
      );
    }

    selectedAddonVariants() {
      const selected = [];
      const blocksByGroup = this.addonGroups();

      if (resourceIsActive(this.config)) {
        this.config.blocks
          .filter((block) =>
            block.type === 'linked_addon' &&
            this.visibleBlock(block) &&
            String(this.state.fields[block.linkedFieldKey] || '') === String(block.linkedFieldValue)
          )
          .forEach((block) => {
            const variant = this.addonVariants(block)[0];
            if (variant) selected.push({ block, variant });
          });
      }

      Object.entries(this.state.addons).forEach(([group, selection]) => {
        if (!selection) return;
        const blocks = blocksByGroup[group] || [];

        blocks.forEach((block) => {
          const variant = this.addonVariants(block).find((item) =>
            String(item.id) === String(selection)
          );
          if (variant) selected.push({ block, variant });
        });
      });

      return selected;
    }

    addonGroups() {
      return this.config.blocks
        .filter((block) => block.type === 'addon' && this.visibleBlock(block))
        .reduce((groups, block) => {
          groups[block.group] ||= [];
          groups[block.group].push(block);
          return groups;
        }, {});
    }

    totalCents() {
      const base = this.selectedVariant?.price || this.productVariants[0]?.price || 0;
      const each = this.selectedAddonVariants().reduce(
        (sum, item) => sum + Number(item.variant.price || 0),
        Number(base)
      );
      return each * this.orderQuantity;
    }

    layoutImage(index) {
      return this.config.product.images[index] || this.config.product.images[0] || null;
    }

    choiceButton({ name, value, label, help, price, selected, image }) {
      return `
        <button
          type="button"
          class="hcob-choice ${selected ? 'is-selected' : ''}"
          data-choice="${escapeHtml(name)}"
          data-value="${escapeHtml(value)}"
          aria-pressed="${selected ? 'true' : 'false'}">
          ${image ? `<img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.alt)}" loading="lazy" width="360" height="280">` : ''}
          <span class="hcob-choice__copy">
            <strong>${escapeHtml(label)}</strong>
            ${help ? `<small>${escapeHtml(help)}</small>` : ''}
          </span>
          ${price !== undefined ? `<span class="hcob-choice__price">${this.money(price)}</span>` : ''}
          <span class="hcob-choice__check" aria-hidden="true">✓</span>
        </button>
      `;
    }

    renderLayout() {
      const selectedIndex = Math.max(0, this.layouts.indexOf(this.state.layout));
      const selectedImage = this.layoutImage(selectedIndex);
      const selectedLabel = this.state.layout || this.layouts[0] || '';

      return `
        ${this.config.showDesignPreview && selectedImage ? `
          <figure class="hcob-design-preview" aria-live="polite">
            <img
              src="${escapeHtml(selectedImage.src)}"
              alt="${escapeHtml(selectedImage.alt)}"
              width="900"
              height="690">
            <figcaption>${escapeHtml(selectedLabel)}</figcaption>
          </figure>
        ` : ''}
        <div class="hcob-layout-grid" role="group" aria-label="${escapeHtml(this.config.labels.gallery)}">
          ${this.layouts.map((layout, index) => {
            const image = this.layoutImage(index);
            const selected = this.state.layout === layout;
            return `
              <button
                type="button"
                class="hcob-layout-thumb ${selected ? 'is-selected' : ''}"
                data-choice="layout"
                data-value="${escapeHtml(layout)}"
                aria-pressed="${selected ? 'true' : 'false'}"
                aria-label="${escapeHtml(this.config.labels.viewDesign)}: ${escapeHtml(layout)}">
                <img
                  src="${escapeHtml(image?.src || '')}"
                  alt=""
                  loading="${index === 0 ? 'eager' : 'lazy'}"
                  width="180"
                  height="138">
                <span>${escapeHtml(layout)}</span>
              </button>
            `;
          }).join('')}
        </div>
      `;
    }

    renderDelivery() {
      const configuredDeliveryFields = this.blocksForStep('delivery');
      const productImage = this.config.product.images?.[0] || null;
      return `
        ${this.config.showProductImageOnDelivery && productImage ? `
          <figure class="hcob-design-preview hcob-product-image" aria-label="${escapeHtml(this.config.product.title)}">
            <img
              src="${escapeHtml(productImage.src)}"
              alt="${escapeHtml(productImage.alt || this.config.product.title)}"
              loading="eager"
              width="900"
              height="690">
          </figure>
        ` : ''}
        <div class="hcob-choice-stack">
          ${this.deliveries.map((delivery) => {
            const copy = this.deliveryCopy(delivery);
            const variant = this.variantForDelivery(delivery);
            return this.choiceButton({
              name: 'delivery',
              value: delivery,
              label: copy.label,
              help: copy.help,
              price: variant?.price,
              selected: this.state.delivery === delivery
            });
          }).join('')}
        </div>
        <p class="hcob-note">${escapeHtml(this.config.labels.shippingNote)}</p>
        ${configuredDeliveryFields.length ? this.renderConfiguredStep('delivery') : ''}
      `;
    }

    renderTextField(block) {
      const value = this.state.fields[block.key] || '';
      const required = block.required ? '<b aria-hidden="true"> *</b>' : '';
      const optional = block.required ? '' : ` <em>${escapeHtml(this.config.labels.optional)}</em>`;

      if (block.inputType === 'textarea') {
        return `
          <label class="hcob-field" ${block.shopifyAttributes || ''}>
            <span>${escapeHtml(block.label)}${required}${optional}</span>
            ${block.help ? `<small>${escapeHtml(block.help)}</small>` : ''}
            <textarea data-field="${escapeHtml(block.key)}" rows="3" placeholder="${escapeHtml(block.placeholder)}">${escapeHtml(value)}</textarea>
          </label>
        `;
      }

      return `
        <label class="hcob-field" ${block.shopifyAttributes || ''}>
          <span>${escapeHtml(block.label)}${required}${optional}</span>
          ${block.help ? `<small>${escapeHtml(block.help)}</small>` : ''}
          <input
            type="${escapeHtml(block.inputType || 'text')}"
            data-field="${escapeHtml(block.key)}"
            value="${escapeHtml(value)}"
            placeholder="${escapeHtml(block.placeholder)}">
        </label>
      `;
    }

    renderFileField(block) {
      const file = this.state.files[block.key];
      const required = block.required ? '<b aria-hidden="true"> *</b>' : '';
      const optional = block.required ? '' : ` <em>${escapeHtml(this.config.labels.optional)}</em>`;
      const accept = block.accept || '.pdf,.jpg,.jpeg,.png,.heic,.heif';

      return `
        <div class="hcob-field hcob-file-field" ${block.shopifyAttributes || ''}>
          <span>${escapeHtml(block.label)}${required}${optional}</span>
          ${block.help ? `<small>${escapeHtml(block.help)}</small>` : ''}
          <label class="hcob-file-picker">
            <input
              type="file"
              name="properties[${escapeHtml(block.propertyName || block.label)}]"
              data-file="${escapeHtml(block.key)}"
              accept="${escapeHtml(accept)}">
            <span>${escapeHtml(file ? this.config.labels.replaceFile : this.config.labels.chooseFile)}</span>
          </label>
          ${file ? `
            <div class="hcob-file-selected">
              <span aria-hidden="true">✓</span>
              <strong>${escapeHtml(file.name)}</strong>
              <button type="button" data-remove-file="${escapeHtml(block.key)}">
                ${escapeHtml(this.config.labels.removeFile)}
              </button>
            </div>
          ` : ''}
        </div>
      `;
    }

    renderChoiceField(block) {
      const choices = this.parseChoices(block.options);
      if (block.control === 'select') {
        const selectedValue = this.state.fields[block.key] || '';
        return `
          <label class="hcob-field hcob-field--select" ${block.shopifyAttributes || ''}>
            <span>${escapeHtml(block.label)}${block.required ? '<b aria-hidden="true"> *</b>' : ''}</span>
            ${block.help ? `<small>${escapeHtml(block.help)}</small>` : ''}
            <select data-field="${escapeHtml(block.key)}">
              <option value="">${escapeHtml(this.config.labels.selectOne)}</option>
              ${choices.map((choice) => `
                <option value="${escapeHtml(choice.value)}" ${selectedValue === choice.value ? 'selected' : ''}>
                  ${escapeHtml(choice.label)}
                </option>
              `).join('')}
            </select>
          </label>
        `;
      }
      const hasImages = choices.some((choice) => choice.image);
      return `
        <div class="hcob-question" ${block.shopifyAttributes || ''}>
          <span>${escapeHtml(block.label)}${block.required ? '<b aria-hidden="true"> *</b>' : ''}</span>
          ${block.help ? `<small>${escapeHtml(block.help)}</small>` : ''}
          <div class="${hasImages ? 'hcob-layout-grid' : 'hcob-choice-stack'}">
            ${choices.map((choice) => this.choiceButton({
              name: `field:${block.key}`,
              value: choice.value,
              label: choice.label,
              help: choice.help,
              image: choice.image ? { src: choice.image, alt: choice.label } : null,
              selected: this.state.fields[block.key] === choice.value
            })).join('')}
          </div>
        </div>
      `;
    }

    renderNotice(block) {
      return `
        <div class="hcob-notice" ${block.shopifyAttributes || ''}>
          <span>${escapeHtml(block.label)}</span>
          ${block.help ? `<small>${escapeHtml(block.help)}</small>` : ''}
        </div>
      `;
    }

    renderAddonGroup(group, blocks) {
      const selection = this.state.addons[group] || '';
      const first = blocks[0];
      const variants = blocks.flatMap((block) =>
        this.addonVariants(block).map((variant) => ({ block, variant }))
      );
      const isToggle = first.control === 'toggle' && variants.length === 1;

      if (isToggle) {
        const item = variants[0];
        return `
          <div class="hcob-addon" ${first.shopifyAttributes || ''}>
            <div>
              <span>${escapeHtml(first.label)}</span>
              ${first.help ? `<small>${escapeHtml(first.help)}</small>` : ''}
            </div>
            <label class="hcob-switch">
              <input
                type="checkbox"
                data-addon-group="${escapeHtml(group)}"
                data-addon-value="${escapeHtml(item.variant.id)}"
                ${selection ? 'checked' : ''}>
              <span aria-hidden="true"></span>
              <b>+${this.money(item.variant.price)}</b>
            </label>
          </div>
        `;
      }

      return `
        <div class="hcob-addon-group" ${first.shopifyAttributes || ''}>
          <div class="hcob-addon-heading">
            <span>${escapeHtml(first.groupLabel || first.label)}</span>
            ${first.groupHelp || first.help ? `<small>${escapeHtml(first.groupHelp || first.help)}</small>` : ''}
          </div>
          <div class="hcob-choice-stack">
            ${this.choiceButton({
              name: `addon:${group}`,
              value: '',
              label: first.includedLabel || this.config.labels.none,
              help: first.includedHelp || '',
              selected: !selection
            })}
            ${variants.map(({ block, variant }) => this.choiceButton({
              name: `addon:${group}`,
              value: variant.id,
              label: block.variantTitle || blocks.length > 1 ? block.label : variant.title,
              help: block.help || '',
              price: variant.price,
              selected: String(selection) === String(variant.id)
            })).join('')}
          </div>
        </div>
      `;
    }

    renderConfiguredStep(stepId) {
      const blocks = this.blocksForStep(stepId);
      const groupsRendered = new Set();

      return `
        <div class="hcob-fields">
          ${resourceIsActive(this.config) && this.config._resourceQuantityEnabled && stepId === 'selection'
            ? this.renderQuantity()
            : ''}
          ${blocks.map((block) => {
            if (block.type === 'text_field') return this.renderTextField(block);
            if (block.type === 'file_field') return this.renderFileField(block);
            if (block.type === 'choice_field') return this.renderChoiceField(block);
            if (block.type === 'notice') return this.renderNotice(block);
            if (block.type === 'addon') {
              if (groupsRendered.has(block.group)) return '';
              groupsRendered.add(block.group);
              return this.renderAddonGroup(
                block.group,
                blocks.filter((item) => item.type === 'addon' && item.group === block.group)
              );
            }
            return '';
          }).join('')}
        </div>
      `;
    }

    renderQuantity() {
      const help = this.config._resourceProfile === 'cover'
        ? 'Choose the number of identical covers. Paid customization is applied once per cover.'
        : 'Choose the number of identical items for this order.';
      return `
        <label class="hcob-field hcob-field--quantity">
          <span>Quantity<b aria-hidden="true"> *</b></span>
          <small>${escapeHtml(help)}</small>
          <input type="number" min="1" step="1" inputmode="numeric" data-hc-quantity value="${this.orderQuantity}">
        </label>
      `;
    }

    reviewRows() {
      const rows = [];
      const stepIndex = (id) => Math.max(0, this.steps.findIndex((step) => step.id === id));

      if (this.hasDesignStep) {
        rows.push({
          label: this.config.labels.reviewDesign,
          value: this.state.layout,
          step: stepIndex('design')
        });
      }
      if (!resourceIsActive(this.config)) {
        rows.push({
          label: this.config.labels.reviewDelivery,
          value: this.deliveryCopy(this.state.delivery).label,
          step: stepIndex('delivery')
        });
      } else if (this.config._resourceQuantityEnabled) {
        rows.push({
          label: 'Quantity',
          value: String(this.orderQuantity),
          step: stepIndex('selection')
        });
      }

      this.config.blocks.forEach((block) => {
        if (
          (block.type === 'text_field' || block.type === 'choice_field') &&
          this.visibleBlock(block) &&
          block.storeProperty !== false &&
          this.state.fields[block.key]
        ) {
          const choice = block.type === 'choice_field'
            ? this.parseChoices(block.options).find((item) => item.value === this.state.fields[block.key])
            : null;
          rows.push({
            label: block.propertyName || block.label,
            value: choice?.label || this.state.fields[block.key],
            step: stepIndex(block.step)
          });
        } else if (block.type === 'file_field' && this.visibleBlock(block)) {
          rows.push({
            label: block.propertyName || block.label,
            value: this.state.files[block.key]?.name || this.config.labels.none,
            step: stepIndex(block.step)
          });
        }
      });

      Object.entries(this.addonGroups()).forEach(([group, blocks]) => {
        const first = blocks[0];
        const selection = this.state.addons[group] || '';
        const selected = this.selectedAddonVariants().find(({ block, variant }) =>
          block.group === group && String(variant.id) === String(selection)
        );
        rows.push({
          label: first.propertyName || first.groupLabel || first.label,
          value: selected
            ? `${selected.block.label} (+${this.money(selected.variant.price)})`
            : first.includedLabel || this.config.labels.none,
          step: stepIndex(first.step)
        });
      });

      return rows;
    }

    renderReview() {
      const imageIndex = Math.max(0, this.layouts.indexOf(this.state.layout));
      const image = this.layoutImage(imageIndex);
      return `
        <div class="hcob-review">
          <div class="hcob-review__visual">
            ${image ? `<img src="${escapeHtml(image.src)}" alt="${escapeHtml(image.alt)}" width="220" height="170">` : ''}
            <div>
              <span>${escapeHtml(this.config.product.title)}</span>
              <strong>${escapeHtml(this.state.layout)}</strong>
            </div>
          </div>
          <div class="hcob-review__rows">
            ${this.reviewRows().map((row) => `
              <div>
                <span>${escapeHtml(row.label)}</span>
                <strong>${escapeHtml(row.value)}</strong>
                <button type="button" data-edit-step="${row.step}">
                  ${escapeHtml(this.config.labels.edit)}
                </button>
              </div>
            `).join('')}
          </div>
        </div>
        <label class="hcob-terms">
          <input type="checkbox" data-accepted ${this.state.accepted ? 'checked' : ''}>
          <span>
            ${escapeHtml(this.config.labels.terms)}
            ${this.config.termsUrl ? `<a href="${escapeHtml(this.config.termsUrl)}" target="_blank" rel="noopener">${escapeHtml(this.config.termsLinkText || 'Read the full disclaimer')}</a>.` : ''}
          </span>
        </label>
      `;
    }

    currentBody() {
      const step = this.steps[this.state.step];
      if (step.id === 'design') return this.renderLayout();
      if (step.id === 'delivery') return this.renderDelivery();
      if (step.id === 'review') return this.renderReview();
      return this.renderConfiguredStep(step.id);
    }

    validateStep() {
      this.state.error = '';
      const step = this.steps[this.state.step];

      if (step.id === 'design' && !this.state.layout) {
        this.state.error = this.config.labels.chooseDesignError;
      } else if (step.id === 'delivery' && !this.state.delivery) {
        this.state.error = this.config.labels.chooseDeliveryError;
      } else {
        const missing = this.blocksForStep(step.id).find((block) =>
          block.required && (
            (
              (block.type === 'text_field' || block.type === 'choice_field') &&
              !String(this.state.fields[block.key] || '').trim()
            ) ||
            (block.type === 'file_field' && !this.state.files[block.key])
          )
        );
        if (missing) {
          this.state.error = this.config.labels.requiredError.replace('[field]', missing.label);
        } else {
          const invalidEmail = this.blocksForStep(step.id).find((block) =>
            block.type === 'text_field' &&
            block.inputType === 'email' &&
            String(this.state.fields[block.key] || '').trim() &&
            !emailIsValid(this.state.fields[block.key])
          );
          if (invalidEmail) {
            this.state.error = `Enter a valid email address for ${invalidEmail.label}.`;
          }
        }
      }

      return !this.state.error;
    }

    mainProperties(group) {
      const properties = {
        '_assistant_order_group': group,
        '_assistant_version': this.config.version
      };

      this.config.blocks.forEach((block) => {
        if (
          (block.type === 'text_field' || block.type === 'choice_field') &&
          this.visibleBlock(block) &&
          block.storeProperty !== false
        ) {
          const rawValue = this.state.fields[block.key] || '';
          const storedValue =
            (String(this.config.version || '').startsWith('international-native') || resourceIsActive(this.config)) &&
              block.type === 'choice_field'
              ? this.parseChoices(block.options).find((choice) => choice.value === rawValue)?.label || rawValue
              : rawValue;
          properties[block.propertyName || block.label] = storedValue;
        }
      });

      Object.entries(this.addonGroups()).forEach(([group, blocks]) => {
        const first = blocks[0];
        const selection = this.state.addons[group] || '';
        const selected = this.selectedAddonVariants().find(({ block, variant }) =>
          block.group === group && String(variant.id) === String(selection)
        );
        const propertyName = selected?.block.propertyName ||
          first.propertyName ||
          first.groupLabel ||
          first.label;
        properties[propertyName] = selected
          ? selected.block.label
          : first.includedLabel || this.config.labels.none;
      });

      properties[this.config.labels.termsProperty] = this.config.labels.termsAccepted;
      if (String(this.config.version || '').startsWith('international-native')) {
        properties['Delivery Method'] = this.deliveryCopy(this.state.delivery).label;
        properties['Shopify Delivery Option'] = this.state.delivery;
        properties['Customer Form Language'] = this.state.viewLanguage || 'English';
        properties['International Form Profile'] = this.config._internationalProfile || this.config.formProfile || '';
        if (this.state.fields.recipient_name) {
          properties["Student's Name_copy"] = this.state.fields.recipient_name;
        }
        if (this.state.fields.gpa) {
          properties['Grade Point Avereage'] = this.state.fields.gpa;
        }
        Object.entries(this.config.staticProperties || {}).forEach(([key, value]) => {
          properties[key] = value;
        });
      }
      if (resourceIsActive(this.config)) {
        properties['Resource Form Profile'] = this.config._resourceProfile || this.config.resourceProfile || '';
        properties['Resource Product Handle'] = this.config.product.handle || '';
        properties['Quantity Requested'] = String(this.orderQuantity);
        properties['Delivery Type'] = this.config.forceDeliveryType || 'product-specific';
        properties['Customer Form Language'] = 'English';
        this.config.blocks
          .filter((block) => Number.isInteger(block.variantOptionIndex))
          .forEach((block) => {
            const optionName = resourceOptionName(
              this.config.product.options?.[block.variantOptionIndex],
              block.variantOptionIndex
            );
            properties[`Shopify ${optionName} Option`] = this.state.fields[block.key] || '';
          });
        this.selectedAddonVariants().forEach(({ block }) => {
          if (block.type === 'linked_addon') {
            properties[block.propertyName || block.label] = this.state.fields[block.linkedFieldKey] || block.linkedFieldValue;
          }
        });
      }
      return properties;
    }

    selectedFiles() {
      return this.config.blocks
        .filter((block) =>
          block.type === 'file_field' &&
          this.visibleBlock(block) &&
          this.state.files[block.key]
        )
        .map((block) => ({ block, file: this.state.files[block.key] }));
    }

    cartPayload() {
      const group = `HC-${Date.now()}-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;
      const quantity = this.orderQuantity;
      const mainItem = {
        id: this.selectedVariant.id,
        quantity,
        properties: this.mainProperties(group)
      };
      const addonItems = [];

      this.selectedAddonVariants().forEach(({ block, variant }) => {
        addonItems.push({
          id: variant.id,
          quantity,
          properties: {
            '_assistant_parent_order_group': group,
            '_assistant_field_name': block.propertyName || block.label
          }
        });
      });

      return {
        group,
        mainItem,
        addonItems,
        items: [mainItem, ...addonItems],
        files: this.selectedFiles(),
        expectedTotal: this.totalCents()
      };
    }

    async removeGroup(root, group) {
      try {
        const cart = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        }).then((response) => response.json());
        const updates = {};
        cart.items.forEach((item) => {
          const properties = item.properties || {};
          if (
            properties._assistant_order_group === group ||
            properties._assistant_parent_order_group === group
          ) {
            updates[item.key] = 0;
          }
        });
        if (Object.keys(updates).length) {
          await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      } catch (_) {
        // The shopper still sees a clear error and can retry or review the cart.
      }
    }

    async addToCart() {
      if (!this.state.accepted) {
        this.state.error = this.config.labels.termsError;
        this.render();
        return;
      }
      if (!this.selectedVariant) {
        this.state.error = this.config.labels.variantError;
        this.render();
        return;
      }

      this.state.busy = true;
      this.state.error = '';
      this.render();

      const payload = this.cartPayload();
      const root = window.Shopify?.routes?.root || '/';
      let partialGroupAdded = false;

      try {
        if (payload.files.length) {
          const formData = new FormData();
          formData.append('id', String(payload.mainItem.id));
          formData.append('quantity', String(payload.mainItem.quantity));
          Object.entries(payload.mainItem.properties).forEach(([name, value]) => {
            formData.append(`properties[${name}]`, String(value ?? ''));
          });
          payload.files.forEach(({ block, file }) => {
            formData.append(
              `properties[${block.propertyName || block.label}]`,
              file,
              file.name
            );
          });

          const mainResponse = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          });
          if (!mainResponse.ok) {
            const problem = await mainResponse.json().catch(() => ({}));
            throw new Error(problem.description || this.config.labels.cartError);
          }
          partialGroupAdded = true;

          if (payload.addonItems.length) {
            const addonResponse = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: payload.addonItems })
            });
            if (!addonResponse.ok) {
              const problem = await addonResponse.json().catch(() => ({}));
              throw new Error(problem.description || this.config.labels.cartError);
            }
          }
        } else {
          const addResponse = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: payload.items })
          });
          if (!addResponse.ok) {
            const problem = await addResponse.json().catch(() => ({}));
            throw new Error(problem.description || this.config.labels.cartError);
          }
        }

        const cartResponse = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        });
        if (!cartResponse.ok) throw new Error(this.config.labels.verifyError);

        const cart = await cartResponse.json();
        const lines = cart.items.filter((item) => {
          const properties = item.properties || {};
          return properties._assistant_order_group === payload.group ||
            properties._assistant_parent_order_group === payload.group;
        });
        const actualTotal = lines.reduce(
          (sum, item) => sum + Number(item.original_line_price ?? item.final_line_price ?? 0),
          0
        );

        if (lines.length !== payload.items.length || actualTotal !== payload.expectedTotal) {
          await this.removeGroup(root, payload.group);
          throw new Error(this.config.labels.verifyError);
        }

        window.location.assign(`${root}cart`);
      } catch (error) {
        if (partialGroupAdded) await this.removeGroup(root, payload.group);
        this.state.busy = false;
        this.state.error = error.message || this.config.labels.cartError;
        this.render();
      }
    }

    bind() {
      const languageRoot = this.closest('[data-hc-product-section]') || this;
      languageRoot.querySelectorAll('[data-hc-language]').forEach((button) => {
        if (button.dataset.hcLanguageBound === 'true') return;
        button.dataset.hcLanguageBound = 'true';
        button.addEventListener('click', () => {
          this.state.viewLanguage = button.dataset.hcLanguage || 'English';
          this.state.error = '';
          this.render();
        });
      });

      this.querySelectorAll('[data-choice]').forEach((button) => {
        button.addEventListener('click', () => {
          const name = button.dataset.choice;
          const value = button.dataset.value;

          if (name === 'layout') {
            this.state.layout = value;
            if (this.config.deliveryUsesDesign) this.state.delivery = value;
            this.updateGallery(value);
          } else if (name === 'delivery') {
            this.state.delivery = value;
            if (this.isDigitalOnly) {
              Object.keys(this.state.addons).forEach((group) => {
                const mailedOnly = this.addonGroups()[group]?.some((block) => block.showFor === 'mailed');
                if (mailedOnly) this.state.addons[group] = '';
              });
            }
          } else if (name.startsWith('field:')) {
            this.state.fields[name.slice(6)] = value;
          } else if (name.startsWith('addon:')) {
            this.state.addons[name.slice(6)] = value;
          }

          this.state.error = '';
          this.render();
        });
      });

      this.querySelectorAll('[data-field]').forEach((input) => {
        input.addEventListener(input.tagName === 'SELECT' ? 'change' : 'input', () => {
          this.state.fields[input.dataset.field] = input.value;
          if (input.tagName === 'SELECT') {
            this.state.error = '';
            this.render();
          }
        });
      });

      this.querySelector('[data-hc-quantity]')?.addEventListener('change', (event) => {
        const quantity = Math.floor(Number(event.currentTarget.value));
        this.state.quantity = Number.isFinite(quantity) && quantity >= 1 ? quantity : 1;
        this.state.error = '';
        this.render();
      });

      this.querySelectorAll('[data-file]').forEach((input) => {
        input.addEventListener('change', () => {
          const block = this.config.blocks.find((item) => item.key === input.dataset.file);
          const file = input.files?.[0] || null;
          const maxBytes = Number(block?.maxFileSizeMb || 20) * 1024 * 1024;
          if (file && file.size > maxBytes) {
            this.state.files[input.dataset.file] = null;
            this.state.error = this.config.labels.fileTooLargeError
              .replace('[size]', String(block?.maxFileSizeMb || 20));
          } else {
            this.state.files[input.dataset.file] = file;
            this.state.error = '';
          }
          this.render();
        });
      });

      this.querySelectorAll('[data-remove-file]').forEach((button) => {
        button.addEventListener('click', () => {
          this.state.files[button.dataset.removeFile] = null;
          this.state.error = '';
          this.render();
        });
      });

      this.querySelectorAll('[data-addon-group]').forEach((input) => {
        input.addEventListener('change', () => {
          this.state.addons[input.dataset.addonGroup] =
            input.checked ? input.dataset.addonValue : '';
          this.render();
        });
      });


      this.querySelector('[data-hc-back]')?.addEventListener('click', () => {
        if (this.state.editingReview) {
          this.state.step = this.reviewStepIndex;
          this.state.editingReview = false;
        } else {
          this.state.step = Math.max(0, this.state.step - 1);
        }
        this.state.error = '';
        this.render();
      });

      this.querySelector('[data-hc-next]')?.addEventListener('click', () => {
        if (!this.validateStep()) {
          this.render();
          return;
        }
        if (this.state.editingReview) {
          this.state.step = this.reviewStepIndex;
          this.state.editingReview = false;
        } else {
          this.state.step = Math.min(this.steps.length - 1, this.state.step + 1);
        }
        this.render();
      });

      this.querySelectorAll('[data-edit-step]').forEach((button) => {
        button.addEventListener('click', () => {
          this.state.step = Number(button.dataset.editStep) || 0;
          this.state.editingReview = true;
          this.state.error = '';
          this.render();
        });
      });

      this.querySelector('[data-hc-add]')?.addEventListener('click', () => this.addToCart());
      this.querySelector('[data-accepted]')?.addEventListener('change', (event) => {
        this.state.accepted = event.currentTarget.checked;
      });
    }

    updateGallery(layout) {
      const index = this.layouts.indexOf(layout);
      const image = this.layoutImage(index);
      const section = this.closest('[data-hc-product-section]');
      const mainImage = section?.querySelector('[data-hc-main-image]');
      if (!image || !mainImage) return;
      mainImage.src = image.src;
      mainImage.alt = image.alt;
      section.querySelectorAll('[data-hc-thumbnail]').forEach((button, buttonIndex) => {
        button.classList.toggle('is-selected', buttonIndex === index);
      });
    }

    render() {
      const current = this.steps[this.state.step];
      const percent = Math.round(((this.state.step + 1) / this.steps.length) * 100);
      const buttonTotal = this.money(this.totalCents());

      this.querySelector('[data-hc-app]').innerHTML = `
        ${this.renderLanguageToggle()}
        <section class="hcob-card" aria-labelledby="hcob-title-${escapeHtml(this.config.sectionId)}">
          <header class="hcob-header">
            <div class="hcob-guide">
              <span class="hcob-mark" aria-hidden="true">HC</span>
              <div>
                <strong>${escapeHtml(this.config.labels.assistantTitle)}</strong>
                <small>${escapeHtml(this.config.labels.stepLabel)} ${this.state.step + 1} ${escapeHtml(this.config.labels.ofLabel)} ${this.steps.length}</small>
              </div>
            </div>
            <div class="hcob-total">
              <span>${escapeHtml(this.config.labels.orderTotal)}</span>
              <strong>${buttonTotal}</strong>
            </div>
          </header>
          <div
            class="hcob-progress"
            role="progressbar"
            aria-valuemin="1"
            aria-valuemax="${this.steps.length}"
            aria-valuenow="${this.state.step + 1}">
            <span style="width:${percent}%"></span>
          </div>
          <div class="hcob-content">
            <div class="hcob-chat">
              <span class="hcob-avatar" aria-hidden="true">✦</span>
              <div>
                <h2 id="hcob-title-${escapeHtml(this.config.sectionId)}">${escapeHtml(current.title)}</h2>
                <p>${escapeHtml(current.subtitle)}</p>
              </div>
            </div>
            <div class="hcob-body">${this.currentBody()}</div>
            ${this.state.error ? `<p class="hcob-error" role="alert">${escapeHtml(this.state.error)}</p>` : ''}
          </div>
          <footer class="hcob-actions">
            <div class="hcob-footer-total" aria-live="polite">
              <span>${escapeHtml(this.config.labels.currentTotal)}</span>
              <strong>${buttonTotal}</strong>
            </div>
            <button type="button" class="hcob-back" data-hc-back ${(this.state.step === 0 && !this.state.editingReview) || this.state.busy ? 'disabled' : ''}>
              ${escapeHtml(this.config.labels.back)}
            </button>
            ${this.state.step < this.steps.length - 1
              ? `<button type="button" class="hcob-next" data-hc-next>${escapeHtml(this.state.editingReview ? this.config.labels.reviewChanges : this.config.labels.continue)} <span aria-hidden="true">→</span></button>`
              : `<button type="button" class="hcob-next" data-hc-add ${this.state.busy ? 'disabled' : ''}>${this.state.busy ? escapeHtml(this.config.labels.adding) : `${escapeHtml(this.config.labels.addToCart)} · ${buttonTotal}`}</button>`
            }
          </footer>
        </section>
      `;

      this.applyVisibleLanguage();
      this.bind();
    }

    showFatalError() {
      const fallback = this.querySelector('[data-hc-fallback]');
      if (fallback) fallback.hidden = false;
      const app = this.querySelector('[data-hc-app]');
      if (app) app.hidden = true;
    }
  }

  customElements.define('hc-order-builder', HCOrderBuilder);

  const showSampleModal = (gallery, requestedIndex) => {
    const samples = [...gallery.querySelectorAll('[data-hc-sample-open]')];
    const modal = gallery.querySelector('[data-hc-sample-modal]');
    if (!samples.length || !modal) return;
    const index = (requestedIndex + samples.length) % samples.length;
    const sample = samples[index];
    const image = modal.querySelector('[data-hc-sample-modal-image]');
    const caption = modal.querySelector('[data-hc-sample-modal-caption]');
    modal.dataset.sampleIndex = String(index);
    image.src = sample.dataset.hcSampleSrc || '';
    image.alt = sample.dataset.hcSampleAlt || '';
    const sampleLabel = gallery.dataset.hcSampleLabel || 'Sample';
    caption.textContent = `${sampleLabel} ${index + 1} of ${samples.length}`;
    if (!modal.open) modal.showModal();
  };

  document.addEventListener('click', (event) => {
    const sample = event.target.closest('[data-hc-sample-open]');
    if (sample) {
      const gallery = sample.closest('[data-hc-samples]');
      const samples = [...gallery.querySelectorAll('[data-hc-sample-open]')];
      showSampleModal(gallery, samples.indexOf(sample));
      return;
    }

    const modalClose = event.target.closest('[data-hc-sample-close]');
    if (modalClose) {
      modalClose.closest('[data-hc-sample-modal]')?.close();
      return;
    }

    const modalArrow = event.target.closest('[data-hc-sample-modal-prev], [data-hc-sample-modal-next]');
    if (modalArrow) {
      const gallery = modalArrow.closest('[data-hc-samples]');
      const modal = modalArrow.closest('[data-hc-sample-modal]');
      const current = Number(modal?.dataset.sampleIndex || 0);
      showSampleModal(gallery, current + (modalArrow.hasAttribute('data-hc-sample-modal-prev') ? -1 : 1));
      return;
    }

    const sampleControl = event.target.closest('[data-hc-samples-prev], [data-hc-samples-next]');
    if (sampleControl) {
      const gallery = sampleControl.closest('[data-hc-samples]');
      const track = gallery?.querySelector('[data-hc-samples-track]');
      if (!track) return;
      const direction = sampleControl.hasAttribute('data-hc-samples-prev') ? -1 : 1;
      track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.82), behavior: 'smooth' });
      return;
    }

    const thumbnail = event.target.closest('[data-hc-thumbnail]');
    if (!thumbnail) return;
    const section = thumbnail.closest('[data-hc-product-section]');
    const image = section?.querySelector('[data-hc-main-image]');
    if (!image) return;
    image.src = thumbnail.dataset.src;
    image.alt = thumbnail.dataset.alt || '';
    section.querySelectorAll('[data-hc-thumbnail]').forEach((button) => {
      button.classList.toggle('is-selected', button === thumbnail);
    });
  });

  const updateSampleControls = (gallery) => {
    const track = gallery.querySelector('[data-hc-samples-track]');
    const previous = gallery.querySelector('[data-hc-samples-prev]');
    const next = gallery.querySelector('[data-hc-samples-next]');
    if (!track || !previous || !next) return;
    const end = Math.max(0, track.scrollWidth - track.clientWidth);
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= end - 2;
  };

  document.querySelectorAll('[data-hc-samples]').forEach((gallery) => {
    const track = gallery.querySelector('[data-hc-samples-track]');
    const modal = gallery.querySelector('[data-hc-sample-modal]');
    updateSampleControls(gallery);
    track?.addEventListener('scroll', () => updateSampleControls(gallery), { passive: true });
    modal?.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-hc-samples]').forEach(updateSampleControls);
  });
})();
